var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.7 181.7",
    style: {
      enableBackground: "new 0 0 134.7 181.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#232012;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#454332;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#2A2717;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#181509;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#32829E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#257086;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#16545E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#070203;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:none;stroke:#46A2C0;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:none;stroke:#59A4D7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:none;stroke:#BFD4C7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:none;stroke:#75BEEA;stroke-linecap:round;stroke-linejoin:round;}\n\t.st12{fill:none;stroke:#9AAEAF;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,173.3c0.3-0.4,4.3,3.8,4.4,3.7c2.6-3.1-13.5-6.8-8.8-12.5c0.1-0.1,4,5,4.9,4.1c3-3.5-22.7-10.4-15.7-18.7 c0.5-0.6-4.3,10.3,2.5,2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,180.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,145.7c0.1-0.1,3.3,2.8,3.3,2.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,154.5c0.4-0.5,3.7,3.6,4,3.3c3.7-4.3-9.4-6.2-6.6-9.6c0,0,5.5,6,6.2,5.2c3.1-3.6-11.6-8.5-8.9-11.8 c0.8-1,7.1,7,7.6,6.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,175.8c0.7-0.8,4.5,4.8,5,4.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,180.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,173.7c0.3-0.4,4,5.1,4.9,4.1c1.1-1.3-9.4-7.2-6.7-10.4c0.7-0.9,1.2,2.5,1.9,1.6c2.3-2.7-7.8-7.3-6.2-9.2 c0.3-0.3,4.6,4.4,4.9,4.1s-17.1-11.4-13-16.3c2.5-3,7.7,10.3,9.6,8.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,157.1c0.7-0.9,5.2,4.6,5.3,4.4c3.7-4.5-9.8-9-8.3-10.7c0.6-0.8,4.2,4.6,4.8,4 c1.6-1.9-28.7-10.7-19.7-21.3c0.1-0.1,8.1,12.3,10.8,9.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,132.5c0.2-0.3,4.7,6.4,5.9,4.9c0.9-1.1-6-6.6-5.1-7.7c0.1-0.1,3.2,3.3,3.5,2.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,158.5c0.1-0.2,3.8,3.2,3.8,3.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.6,157.8c1-1.1,6.8,6.5,7.2,6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,165.2c0.3-0.3,3.6,3.9,4,3.4c1.7-2.1-3.7-6.2-2.9-7.2c0.2-0.2,3.3,3,3.4,2.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,171.7c8.3-9.9,5.6,6.5,6.5,5.4c5-6-16.2-9.6-12.1-14.6c3.7-4.4,5.2,8.9,7.4,6.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,174.3c0.5-0.6,5.4,5.6,6,5c2.3-2.7-3.3-6.4-3.2-6.6s3,2.7,3.1,2.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2,180.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.6,181.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,181.2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,177.3c0-0.1,3.5,3.5,3.8,3.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,166.8c0.6-0.8,4,4.5,4.5,3.8c0.1-0.1-10-6.2-7-9.8c0.2-0.3,4.2,4.9,4.9,4.1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,166.9c0.1-0.2,3.4,3.9,3.9,3.3c0.7-0.8-8.9-10.4-8.3-11.1s5.1,7.1,6.5,5.4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,158.4c1.1,0.8,2.1,1.7,3.2,2.6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,156.2c0.2-0.3,3.5,3.1,3.5,3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,158.7c0.2-0.2,3.2,2.8,3.2,2.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,151c0-0.1,2.9,2.6,3,2.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,162.5c2-2.4,2.2,2.2,2.4,2c0.5-0.6-15.4-11.5-11.9-15.7s-0.6,11.3,5.2,4.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,180"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,132.9c0.4-0.4,3.7,3.1,3.7,3.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,145.5c1.8-2.1-1.4,2,0.2,0.2c2.3-2.7-11.5-6.7-8.5-10.3c4.6-5.5,13.7,11.8,13.9,11.6 c5.9-7-18.9-6.6-12.9-13.8c1.8-2.1,6.4,10.1,8.7,7.3c1.3-1.5-7.5-5.2-4.4-9c0,0,3.1,2.7,3.1,2.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,142.6c0.8-0.9,4.6,6.3,5.8,4.9c2.3-2.8-9.3-9.5-7.8-11.2c0.7-0.8,7.3,8.1,8.3,6.9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,150.7c0.4-0.5,4.2,4.3,4.5,3.8c2.1-2.4-7.2-5.8-5-8.3c0,0,2.9,2.5,2.9,2.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,172.7c0.3-0.3,4.3,4.7,4.9,4.1c0.9-1-11.8-7.5-8.5-11.3c0.2-0.2,4.3,4.9,5,4.2c3.5-4.2-13.5-6.2-8.8-11.8 c0.1-0.1,4.6,4.9,5.1,4.3c3.1-3.7-12-8.6-8.6-12.6c0,0,5.8,8,7.4,6.2c2.3-2.7-4.9-7.5-4.9-7.5c0.4-0.4,3.7,4,4.1,3.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,177.5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,162.7c0.1-0.1,2.9,2.6,3,2.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,161.9c0.3-0.4,3.4,3.3,3.6,3.1s-9.1-6.9-6.3-10.2c0.3-0.3,3.1,3.1,3.4,2.8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,171.3c0.1-0.1,3.6,4,4.1,3.4c1.3-1.6-9.7-9.5-8-11.5c0.7-0.8,6.3,8.1,7.7,6.4c0.7-0.9-7.5-10.3-7.2-10.6 c0,0,3.7,3.2,3.7,3.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,179.8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.9,176.7c0.1-0.2,3.2,2.7,3.2,2.7c1.5-1.7-7.3-10.6-7.2-10.7c0.8-1,4.9,4.3,5,4.2c2.4-2.9-9.7-10.2-8.5-11.6 c0.7-0.8,4,5.1,4.8,4.1c1.2-1.4-8.3-7.7-6.7-9.5c0.1-0.1,3.4,3,3.5,2.9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,170.6c0.2-0.3,4.2,5.3,5.1,4.3c3.5-4.2-12.3-7.4-8.7-11.7c0.5-0.6,4.8,4.5,5,4.2c3.4-4-9-10.5-8.3-11.3 c0.2-0.2,4.9,4.7,5.2,4.3c1.6-1.9-9.4-5.7-6.7-8.9c0.2-0.2,3.4,3.2,3.6,3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,178.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,169.2c0.6-0.7,4.5,4.9,5,4.2c2.7-3.2-8.4-11.8-8-12.3c0.3-0.3,3.6,3.5,3.9,3.2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,173.6c0.1-0.1,6.9,6.3,7.1,6c2-2.3-7.7-7.6-6.7-8.9c0.7-0.9,4.1,4.4,4.5,3.9c0.8-0.9-11.1-5.5-7.3-10.1 c0.1-0.1,4,4.8,4.7,4c3.5-4.2-11-9.8-8.9-12.4c0.8-1,4.7,5.6,5.5,4.7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2,175.4c0.9-1.1,4.3,5.3,5.2,4.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.8,179.4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,178.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.3,172.4c0.3-0.4,4.2,4,4.4,3.7c1.5-1.8-10.5-10.4-8.4-12.9c0.2-0.2,4.4,4.1,4.6,3.9 c1.7-2-8.8-10.6-8.1-11.5c0.5-0.7,4.9,5,5.3,4.4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,173c0.8-0.9,4.7,5.1,5.3,4.4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,179.2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.7,171.2c0.8-0.9,4.4,5,5,4.2c3.5-4.2-9.4-10.9-8.4-12.1c0.1-0.1,4.1,5,4.9,4.1c2.4-2.9-10.4-5.6-7.2-9.5 c0.8-1,4.4,5.1,5.1,4.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,135.4c0.5-0.6,4.7,4.2,4.8,4c3.2-3.8-8.5-9.5-7.7-10.4c0.6-0.7,3.7,4.1,4.2,3.5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,131.7c0.1-0.1,3.7,4.3,4.3,3.6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,128.5c0.3-0.3,4.8,4.2,4.9,4.1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,134.6c3.3-4,11.8,10.2,11.9,10c1.1-1.3-15.9-13.8-14.2-15.9c1.7-2.1,10.8,10.8,11.6,9.8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,145.1c0.2-0.3,4.3,4.1,4.5,3.8c1.3-1.5-10.7-7.3-8.3-10.3c0.7-0.8,4.9,5,5.3,4.5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,120.9c0.4-0.4,3.6,3.6,3.9,3.3c0.6-0.7-1.7-2.9-0.4-4.5c0.4-0.4,3.7,3.7,4,3.4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.4,119.8c0.2-0.2,3.1,2.8,3.2,2.7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,118.3c0.1-0.1,3.1,2.6,3.1,2.6c0.8-0.9,1.2-2,1.9-2.8c0,0,3.2,3.1,3.4,2.8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,116.9c0,0,3,2.5,3,2.5c0.8-1-0.5-1.9,0.4-3c0.1-0.1,3.1,3.2,3.4,2.9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,114.6c1.2,0.9,2.4,1.9,3.5,3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,113c0.1-0.1,3.2,2.8,3.2,2.7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,123.1c0.4-0.5,2.7,3.2,3.1,2.6c0.4-0.5-0.5-2.7,0-3.3c0.2-0.2,3.4,3.6,3.7,3.1c0.7-1,1.3-2.1,1.8-3.3 c0.2-0.2,3.3,2.9,3.3,2.8c0.8-0.9-3.9-4.1-2.3-6.1c0.4-0.5,3.7,3.2,3.8,3.2c0.4-0.4-3.7-4.2-2.3-5.9c0-0.1,3.2,2.9,3.3,2.8 c1.1-1.3-4.8-4.8-2.3-7.8c0.2-0.2,3.9,3.6,4.1,3.4c0.4-0.5-3.2-3.6-1.3-5.9c0.1-0.1,3.1,2.7,3.1,2.6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,123c1.4-1.6,5.5,6.4,6.4,5.4s0.9-2.5,2.1-3.9c0.4-0.4,3.5,3.6,3.8,3.2c0.5-0.6-0.5-3.7,0-4.2 c0.2-0.2,3.1,2.8,3.2,2.7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,124.4c0.5-0.6,6.4,10.1,8.7,7.3c0.7-0.8-1.9-3.2-1-4.4c0,0,3.9,4.2,4.4,3.7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,125.4c2.3-2.8,10.5,10.5,11.3,9.6c1-1.2-1.7-4.6-1.6-4.7s3.4,3.6,3.8,3.2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,131.1c0.6-0.7,3.8,9.6,6.9,5.8c1-1.2-0.3-3.7,0.2-4.3c0.7-0.8,5.4,8,7.1,6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,138.7c0.3-0.4,3.7,4,4.1,3.5c1.6-1.9-2.5-3.9-1.2-5.5c0.2-0.3,3.9,3.2,3.9,3.2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,128c0.3-0.4,1.6,1.4,1.6,1.4c0,0-0.2-4-0.1-4.1c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,128.9c0.2-0.2,3.5,3.3,3.7,3.1c0.2-0.2-1.6-3.6-1-4.3c0.2-0.2,3.2,2.8,3.2,2.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,131.7c0.7-0.8,4.2,4.7,4.7,4s-2.7-4.6-1.1-6.5c1.1,1,2.2,2,3.4,2.9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,133.7c0.1-0.2,3.5,3.9,4,3.3c0.7-0.9-0.7-5.4-0.6-5.6c1,1,2.1,1.9,3.2,2.7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,135.4c0.3-0.4,3.7,3.3,3.8,3.2c1-1.2-2.2-4.6-1.3-5.6c0.1-0.1,3.2,3,3.4,2.8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,138.9c0.9-1.1,5.1,4.7,5.3,4.4c1.9-2.3-4.9-4-3.1-6.2c0.1-0.1,3.5,3.4,3.7,3.1c1.2-1.5-3.2-3.7-1.8-5.3 c0.1-0.1,3.1,3.1,3.3,2.8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.2,142.9c0.3-0.3,3.8,3.5,4,3.3c0.1-0.2-4-3.9-2.6-5.6c0.6-0.7,4.2,5.4,5.1,4.3c0.9-1-0.3-3.3-0.2-3.4 c0.1-0.1,3,2.6,3,2.6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,148.4c0,0,5.9,5.3,6,5.1c6.5-7.7-16.7-12.9-13.4-16.8c2-2.3,8.1,7.7,8.5,7.1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,175.7c0.5-0.6,4.7,3.9,4.7,3.9c3.4-4.1-8.9-9.3-7.5-11c0.7-0.9,4,4.4,4.5,3.8c6.8-8.1-34.5-21.7-28-29.5 c4.4-5.2,19.7,24.7,23.7,19.9c0.3-0.4-11.9-7.2-8.1-11.7c0.9-1.1,4.7,4.6,5,4.2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,147.8c0,0,3.1,2.8,3.2,2.7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,172.5c0.5-0.6,3.9,4.7,4.6,3.9c2.8-3.4-9.4-7.1-7.2-9.9c0.4-0.5,4.4,4.2,4.7,3.9c2.3-2.7-10.2-5.6-7-9.4 c0.3-0.4,4,5,4.8,4c4.9-5.9-10.5-11.3-9-13.1c0.2-0.3,3.9,5,4.8,4c1.3-1.6-9.5-7.5-7.5-9.9c0.3-0.3,4.5,5,5.1,4.3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,178.8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.9,171.6c0.3-0.3,4.4,4.7,4.9,4.1c1.9-2.3-10-10.2-8.3-12.3c0.5-0.7,4.3,4.1,4.5,3.8 c1.8-2.1-7.9-11-7.6-11.5c0.1-0.1,3.9,4,4.2,3.5c2-2.4-5.6-8.7-4.9-9.5c0.3-0.4,3.5,3.8,3.9,3.3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,180.5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,177.9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,173.3c0.1-0.1,3.9,4.5,4.5,3.8c0.8-1-10.3-5.8-6.9-9.9c0.1-0.1,3.9,4,4.2,3.5c3.7-4.4-11.4-6.5-7.6-11.1 c0-0.1,4.3,3.9,4.5,3.7c3.4-4-10.6-5.9-7.1-10c0.6-0.7,4.2,3.8,4.3,3.6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,172.4c0.8-1,4.4,5.2,5.2,4.3c0.3-0.4-11.6-7.3-8.2-11.3c0.3-0.4,4,4,4.3,3.6c3.3-4-6.8-7.6-6.1-8.6 c0-0.1,3.9,3.6,4.1,3.4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,177.8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,168.7c0.8-0.9,1.9,2.6,2.4,2c0.5-0.6-9.2-8-6.8-10.9c0-0.1,3.3,3.1,3.4,2.9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.4,172.6c0.5-0.5,7.4,6.5,7.5,6.3c2.1-2.5-9.6-7.5-7.3-10.2c0.2-0.3,4.4,3.7,4.4,3.7 c1.1-1.3-11.3-6.6-7.3-11.3c0.6-0.7,5.4,6.4,6.3,5.3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.8,173.8c0.6-0.7,4.6,5.5,5.4,4.5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,180.7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,181.1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,176.9c0.7-0.9,4.7,3.9,4.7,3.9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,164.6c0,0,3.2,2.7,3.2,2.7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.7,173.4c0.8-1,5.6,6.1,6.3,5.3c3.5-4.2-8.9-7.3-6.3-10.3c0.1-0.1,3.9,3.6,4,3.4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,169.9c0.2-0.3,4,3.9,4.2,3.5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,172.1c0.1-0.1,4,3.5,4,3.4c0.2-0.2-5.5-5.4-3.2-8.1c0.3-0.4,2,1.6,2,1.6c0.6-0.6-6.9-7.2-5.8-8.6 c0.5-0.5,4.3,4.7,4.9,4.1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,171.3c0.2-0.3,3.3,3.3,3.6,3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,177.2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,166.9c0.3-0.4,3.2,3.4,3.5,3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,178c1.3-1.6-0.3,3.3,1.4,1.2c4.6-5.5-18-9.8-13.3-15.4c0,0,3.3,2.7,3.3,2.7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,175"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.4,181.6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,173.9c2-2.4-1,2.8,0.8,0.7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.6,168.6c4.1-4.9-0.4,7.1,3.2,2.7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,175.6"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,170.9c0.5-0.6,3.9,4.2,4.3,3.6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.5,173.9c0.5-0.5,4.9,5.7,5.7,4.7c1.8-2-11.6-8.5-9.6-11c5.9-7-5,6.4,0.2,0.2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,173.7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.7,180.3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,158.6c0.6-0.7,4.3,4.6,4.8,4c1.8-2.2-3.6-5.8-2.5-7.1c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.1,158.3c0.3-0.3,7.3,11.1,9.8,8.2c3.1-3.7-9.2-5.2-6.4-8.6c1.1-1.3,6.6,7.1,7.3,6.2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,161.8c1.7-2,9.9,9.1,10.3,8.7c0.1-0.1-3.1-5.7-2.7-6.1c0.1-0.1,3,2.6,3,2.5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,168.3c1.5-1.8,5.9,6.1,6.5,5.4s-9.1-6.9-7.2-9.2c1.7-2,6,7.6,7.3,6.1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.3,164.2c0.7-0.8,2.8,4.7,3.9,3.3c1.3-1.6-12.5-6.6-8.6-11.3c0.2-0.2,8.1,12.6,11,9.2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,165.8c0.3-0.3,4.6,6.4,5.8,4.9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.3,172"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.9,181.5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,180.7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.7,159.3c8.7-10.3,9.7,32.2,21.5,18"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83,151.2c0.2-0.2,3.2,3.1,3.4,2.9c1.8-2.1-6.2-4.2-4-7c0.1-0.1,3.2,2.8,3.3,2.7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.2,147.9c0,0,3.1,3,3.3,2.8c2-2.4-4.7-5.7-4.1-6.4c0-0.1,3,2.5,3,2.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,149.2c1.1,0.9,2.2,1.8,3.3,2.7c3.2-3.8-6.6-7-4.7-9.3c0.2-0.2,3.2,2.9,3.3,2.7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,171.2c4.6-5.5-2.2,6,1.6,1.4c0.9-1.1,2.4,0.2,3.5-1.1c1.8-2.1,4.5,4.6,4.9,4.1c0.6-0.7-21.3-18-19.8-19.8 c4-4.8,12.7,20,17.3,14.5c5-5.9-12.9-9.2-10.2-12.5c0.1-0.1,7.6,14.1,11.3,9.5c0.1-0.1,1.2-1.5,2.3-2.7c0,0,3.3,3.3,3.6,3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,159.4c1.1-1.3,6.6,9.1,8.4,7c0.6-0.8-5.3-7-4.5-7.9c0,0,3.1,3,3.3,2.8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,148c0.3-0.4,3.3,3.5,3.7,3.1c1.1-1.3-5.3-6.2-4.5-7.3c0.7-0.9,1.7,1.5,1.7,1.5c0.6-0.8-3.4-3.9-2.3-5.3 c0.1-0.1,3.3,3.4,3.6,3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.9,149.6c1.5-1.8,12.1,13.2,13.6,11.3c1.5-1.8-7-5.5-3.9-9.1c1.2,0.9,2.3,1.8,3.3,2.8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,142.7c0.1-0.1,3.2,2.7,3.2,2.7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.9,147.7c0.4-0.4,3.6,3.4,3.8,3.2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.8,149.4c0.4-0.5,3.6,3.5,3.8,3.2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,151c1.1,1,2.2,1.9,3.3,2.8c0,0-3.4-4.7-2.7-5.5c0,0,3,2.7,3.1,2.6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.3,147c0.6-0.8,3.3,3.1,3.4,2.9c1.2-1.5-9.4-9.4-8.4-10.6c0.1-0.1,7.5,10.7,9.7,8.1c3.4-4-11-8.1-7.8-11.8 c0.1-0.2,3.2,3.1,3.4,2.8c0.4-0.4-4.3-5.6-2.5-7.7c0.2-0.2,3.9,4.4,4.4,3.7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.2,175.2c0.3-0.3,4.8,4.1,4.8,4.1c1.3-1.6-4.7-7.5-3.8-8.6c0.2-0.3,1.7,1.5,1.7,1.4c0.6-0.7-3-5.9-2.5-6.5 c1,0.9,2,1.7,3.1,2.5c2-2.5-5.3-5.8-3.4-8.1c0,0,2.9,2.4,2.9,2.4c0.4-0.5-5.8-6.2-3.7-8.7c0,0,2.8,2.4,2.8,2.4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.3,180.8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,129.7c0.2-0.3,3.3,3,3.4,2.9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.7,126.1c1,0.9,2,1.8,3.1,2.6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.2,123.1c0,0,2.9,2.6,3,2.5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.4,122.2c0.5-0.6,5,4.3,5,4.2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.8,133.2c0.2-0.2,4.6,4.4,4.8,4.1c1.7-2-10.3-10.2-8.6-12.1c0.4-0.5,4.9,7,6.3,5.3c0.5-0.6-1.9-3.8-0.2-5.8 c0.1-0.2,3.2,3.1,3.4,2.9c0.2-0.2-3.7-5-2.3-6.7c0.9-1.1,4.5,4.9,5,4.2c1.4-1.7-3.1-5.5-2.7-6c0.2-0.2,4.2,3.7,4.3,3.6 c1.6-1.8-2.4-4.8-2.3-5c0.8-0.9,4.5,5.1,5.1,4.3c0.7-0.9,2-2.9,2.3-3.2s3.7,3.3,3.8,3.2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.3,116.8c0.1-0.2,3.7,4.3,4.3,3.6c0.9-1.1,0.6-2.5,1.3-3.4c0.3-0.3,3.5,3.2,3.6,3"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.1,115.2c0.4-0.4,3.9,3.5,4,3.4c0.9-1.1-0.2-2,0.8-3.2c0.3-0.3,3.3,3,3.4,2.8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.2,113.7c0,0,3.5,3.4,3.7,3.1c0,0-0.5-2.9-0.1-3.3c0.1-0.1,3.7,3.8,4,3.4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,112.2c0.2-0.2,3.4,3.3,3.6,3c0.2-0.3-1.1-4,0.1-5.5c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,173.4c0.2-0.3,3.3,2.9,3.4,2.8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.1,171.3c0.2-0.2,8.7,10.3,10.2,8.5c0,0-7.2-7-6.1-8.3c0,0,3,2.7,3.1,2.6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.7,178.4c0.2-0.2,3.3,3.1,3.5,2.9c3.4-4.1-9.9-9-7.7-11.6c0.2-0.2,3.6,3.3,3.7,3.1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7,181.5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.9,178.2c0.2-0.3,3.3,3,3.4,2.8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.9,171.5c0,0,3.9,4.2,4.4,3.7"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.4,179.1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.9,175.6c0.2-0.2,4.6,5.8,5.5,4.6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.5,168c0.6-0.7,5.6,4.9,5.7,4.8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.8,180.7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.8,171.8c0.5-0.6,3.9,4.1,4.3,3.6c3.1-3.7-10.9-11.1-9.3-13c0.5-0.6,4.5,4.2,4.7,4"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.7,174.6c1.9-2.3,7,7.1,7.6,6.4c0.4-0.5-9.5-13.9-9.5-13.9c0.2-0.2,4.1,5.2,5,4.2c3.7-4.3-12.2-8.4-9.1-12.2 c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.3,181.8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.9,170.2c0.7-0.9,5.3,4.9,5.5,4.6c3.2-3.8-10.1-5-6.5-9.3c0.1-0.1,3,2.6,3,2.5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.2,176.8c0,0,3.9,3.8,4.2,3.5c0,0-0.7-3-0.3-3.5c0,0,3,2.8,3.1,2.6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.9,175.5c0,0,3.5,3.7,3.9,3.2c3.1-3.7-10.7-7.2-7.7-10.7c0.3-0.4,3.6,4.3,4.2,3.5s-10.5-8.2-7.4-11.8 c0.1-0.1,3,2.8,3.1,2.6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,121.2c0.2-0.3,4.5,3.8,4.5,3.7c0.7-0.9-0.4-4.6,0.2-5.3c0.6-0.7,3,2.8,3.1,2.6c0.5-0.6-1.2-4.6-0.8-5.1 c0,0,4.2,4.9,4.9,4.1c1.5-1.7-2.4-4.5-1-6.1c0.4-0.5,4.2,4.9,4.9,4.1c0.2-0.3-0.6-3.8,0.5-5.1c0.1-0.1,3.1,3,3.3,2.8"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.4,146.9c0.1-0.1,3.3,2.9,3.3,2.8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.3,180.9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.2,178.7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.8,172.4c0.1-0.2,0.5,0.5,0.5,0.4c0.1-0.9,0.2-1.9,0.2-2.9c1-1.2,4.9,6,5.8,4.9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105,164.3c0,0,2.9,2.4,2.9,2.4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,159.6c0.2-0.2,5.1,7.6,6.7,5.7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.9,157.2c0.2-0.2,4.9,4.6,5.1,4.3c2.2-2.5-6.2-8.2-5.8-8.7c0.5-0.6,6.9,6.2,7.1,6"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.9,150.8c0-0.1,3,2.5,3,2.5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.6,153.2c0,0,2.9,2.6,3,2.5c1.8-2.2-4-4-2.3-6c0.6-0.7,4.7,4.8,5.1,4.3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.2,147.5c0.2-0.3,3.2,3.1,3.4,2.9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.4,143.6c3.8-4.5,9.9,14.1,12.8,10.7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.3,137.8c3.1-3.6,12.8,21.6,18.1,15.2c2.6-3.1-25.7-11.7-18.1-20.7c0.4-0.5-1.5,9.7,3.9,3.2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.6,130.3c0.1-0.1,2.9,2.7,3.1,2.6c1-1.2,6.6,3.1,7.1,2.6c1.2-1.4-3.7,7.3,1.4,1.2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.1,144.3c0.1-0.1,3.4,3.1,3.5,2.9c4-4.8-19.3-12-15.3-16.7c1.7-2.1,13.3,12.1,13.8,11.5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,138.8c0.5-0.6,4,4.2,4.5,3.7c3.5-4.2-15-6.8-10.4-12.3c2.1-2.5,11.2,11.3,12.1,10.2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.9,143.5c4.7-5.7,2.3,18,10.2,8.6c0.8-1,3.9-1.7,4-1.9c0.1-0.2,3.2,3.1,3.4,2.9c0.9-1.1-8.1-6.5-5.8-9.2 c0,0,3.6,3.2,3.7,3.1c4.1-4.9-22.5-11.4-16.7-18.3c0.8-0.9,10.7,18.2,15.3,12.8c6.2-7.3-18.2-14.6-16.4-16.7 c4.1-4.9,14.6,16.8,16.9,14.1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.2,161.2c0.2-0.2,3.1,2.8,3.2,2.7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.2,163c0.3-0.3,4.8,4.4,4.9,4.1c0.2-0.2-5.8-7.1-5.3-7.7c1.1-1.3,0.7,3.1,1.9,1.6c2.8-3.4-6.3-6.1-4.7-7.9 c0.1-0.1,9.3,10.9,10.9,9.1c0.2-0.2-4-4-2-6.4c0,0,3.3,3.2,3.5,3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.1,165.3c0.3-0.3,5.4,7.2,6.7,5.6"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113,165.5c0.6-0.7,3.9,4.4,4.5,3.8c0.5-0.6-1.4-3.5-1-4c0.2-0.3,0.5,0.4,0.5,0.4c0.5-0.6-1.9-3.3-1-4.3 c0,0,2.9,2.7,3,2.5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.9,178.9c0.6-0.7-5.3-4-3.1-6.8c1.8-2.2,5,8.4,7,5.9c0,0-10.7-7-7.8-10.4c1.3-1.6,6.3,10.1,8.6,7.3 c1.3-1.5-10.6-9.2-8.6-11.6c1.2-1.4,5.9,9.4,8.1,6.8c3.1-3.7-11-10.6-10.1-11.8c1-1.2,9,9.5,9.9,8.3c2.1-2.5-11.2-6.7-7-11.7 c1-1.2,7.5,6.7,7.7,6.4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.5,177.8"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.8,173.4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.7,180.8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.9,153.4c2-2.3,7.2,9.2,8.8,7.4c2.9-3.5-10.7-10-9.2-11.8c0.2-0.3,3.5,3.1,3.6,3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.5,144.3c0.1-0.1,3.4,3.6,3.7,3.1c3.8-4.5-13.7-8.1-10.4-12.1c3.7-4.4,3.9,6.7,5.6,4.7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.7,143.4c0.2-0.2,3.5,3,3.5,3c3.8-4.5-12.4-5.7-8.1-10.8c1.4-1.7,5.5,6.1,6.2,5.2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.8,145.2c0.1-0.1,5.1,5.5,5.7,4.8c0,0-3.7-4.9-3-5.8c0.1-0.1,3.5,3.5,3.8,3.2"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.2,178.2c0.4-0.4,3.7,3.5,3.8,3.2s-7.4-5.8-5.7-7.8c0.6-0.7,4.4,5.7,5.4,4.5c1.6-1.8-6.8-7.1-4.8-9.5 c0.4-0.3,4.8,4.2,4.9,4.1c1.6-1.9-6.6-8.6-5.4-10c1-1.2,4.5,4.2,4.7,3.9c1.6-1.9-12.2-12-10.9-13.6c0.1-0.1,8.8,13,11.6,9.7 c4.3-5.1-14.8-9.6-10.8-14.3c1.5-1.8,7.7,11.2,10,8.4c0.8-1-16.3-10.5-12-15.6c0.3-0.4,4.7,5.9,5.6,4.7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.7,181.8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47,137.4c5-5.9-4.8,7.3,0.8,0.7c0.8-1-1-3.9,0.2-5.4c6.8-8.1,8.5,16.8,13.3,11.2c1.9-2.3-18.6-9.2-12.7-16.3 c5.1-6.1,0,3.1,1.6,1.3c2.4-2.8-6.8-4.1-4.1-7.3c0.2-0.2,3.1,2.8,3.2,2.7"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38,113.7c0,0,3.2,3,3.3,2.8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.7,115.3c0.7-0.9,5.1,6.5,6.2,5.2c0.6-0.7-9.3-7.6-6.5-11c0.1-0.1,3.3,3.3,3.6,3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.8,119.5c0.2-0.2,4.3,5.1,5,4.2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.2,117.5c0.5-0.5,1,0.8,1,0.8c1-1.2-6.4-5.3-4.7-7.3c0.2-0.3,3.7,4.3,4.3,3.6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.2,108.2c0.3-0.2,4,3.4,4,3.4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.9,115.7c0.4-0.4,3.4,3.3,3.6,3.1c3.2-3.8-10-10.3-9.1-11.5c0.4-0.4,6.3,5.7,6.5,5.5 c2.8-3.4-6.7-7.8-6.2-8.3c0.5-0.6,3.9,4.1,4.3,3.6c1.8-2.1-4.5-7.2-3.7-8.2c0.2-0.2,3.4,2.9,3.4,2.8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.6,124.9c0.7-0.9,8.3,13.9,11.7,9.8c5-6-18.1-10.8-13.7-16c0.6-0.8,4.4,4.3,4.7,3.9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.1,143.3c0.9-1.1,4.6,6.1,5.7,4.8c0.8-0.9-0.3-3.4,0.9-4.9c1.2-1.5,6.5,7.2,7.4,6.2 c1.4-1.7-12.9-7.5-8.5-12.8c3.3-3.9,14.1,13.8,15.1,12.7c1-1.1-0.5-2.1,0.6-3.4c0.2-0.3,3.2,2.9,3.3,2.8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.7,126.5c0,0,3,2.7,3.1,2.6c0.7-0.8-0.9-2.9,0.2-4.2c0,0,3.5,3.4,3.7,3.1c0,0-1.6-3.6-1.1-4.2 c0,0,3.2,3.1,3.4,2.9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.6,138.9c1.2-1.5,9.4,9.1,10,8.4c2.7-3.2-4.7-7.2-3.9-8.1c1.3-1.5,6,7,6.9,5.8c0.5-0.6-3.4-5.4-2.1-6.9 c0.6-0.7,5.2,4.5,5.2,4.4c0-0.1-3.3-6.1-2.3-7.2c0.5-0.5,4,3.7,4.1,3.5s-5.8-5-4.4-6.7c0.6-0.7,4.5,5.8,5.5,4.6 c1.2-1.4-4.3-5.9-2.7-7.8c0.3-0.3,4.9,4.2,4.9,4.1c0.9-1.1-1.7-5.5-1.1-6.3c0.2-0.3,1.7,1.5,1.7,1.5c0.6-0.7-2.7-5.7-2.2-6.3 c0,0,4,4.4,4.5,3.8c1.7-2-3.6-5-2-6.9c0.2-0.3,3.5,3.4,3.7,3.1c0.2-0.3-1.3-4.2-0.1-5.7c0,0,2.9,2.5,2.9,2.5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.6,167.8c0.1-0.1,3.3,3.2,3.5,2.9c0.9-1.1-5.3-5.3-4.2-6.7c0.2-0.2,3.1,2.9,3.3,2.7"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.2,161.9c0.2-0.3,3.1,3.2,3.4,2.8c1.6-1.9-8-5.1-5.6-8c0.1-0.1,3.9,4.9,4.7,3.9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.4,151.5c0.1-0.1,3.3,2.9,3.4,2.8c3.1-3.6-9.1-11.7-8.4-12.5c0.2-0.2,4.3,3.8,4.4,3.7"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.9,143.1c0.1-0.1,3.1,2.7,3.1,2.6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.4,146c0-0.1,3.4,3.6,3.8,3.2c1.1-1.3,0-2.5,1-3.6c0.1-0.1,3.1,2.7,3.1,2.6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.5,162.6c0.3-0.3,2.2,2,2.3,1.9c0.9-1-10.7-9.7-9-11.7c0.3-0.3,3.9,3.4,4,3.3c0.1-0.1-4.7-6.8-4.2-7.3 c0-0.1,2.9,2.4,2.9,2.4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.3,164.5c0.3-0.3,3.3,3,3.4,2.8c0.7-0.9-11.3-8-9-10.7c3.1-3.7,8.6,11.9,10.9,9.1"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.7,152.7c0.2-0.2,8.1,12.6,11,9.2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49,149.8c0.3-0.4,3.3,3.3,3.6,3c1.9-2.3-2.2-6.6-2.1-6.7c0.3-0.4,3.3,3.5,3.6,3.1c0.8-1-1.9-5.6-1.5-6.1 c0,0,3,2.8,3.1,2.6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59,165.4c0.1-0.2,4.1,3.5,4.1,3.4c1.4-1.7-6.7-7.7-6-8.5s4.6,4.9,5.1,4.3c2.6-3.1-11-13.3-10.3-14.2 c0.2-0.3,3.3,3.5,3.7,3.1c0.2-0.2-4.5-4.2-2.3-6.7c0.1-0.1,3.6,3.3,3.7,3.1c1.1-1.4-3.1-4.6-2-5.9c0.1-0.1,3.2,2.6,3.2,2.6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.6,166.5c0.4-0.5,4.4,4,4.5,3.8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.9,164.7c0-0.1,3.3,3.4,3.6,3c3.5-4.2-9.7-9.1-8.7-10.3c1.4-1.6,6.8,7.2,7.5,6.3"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.3,163.7c0.6-0.7,4,4.1,4.4,3.7"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57,155.6c0,0,3.6,3.7,3.9,3.3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.9,157.8c0.2-0.2,3.2,3.1,3.4,2.9c1.6-1.8-8.9-4.9-5.9-8.5c0-0.1,3.3,3.3,3.5,3c0.4-0.5-3.8-5-2.9-6.2 c0.2-0.2,3.3,3.3,3.6,3c0.4-0.5-2.9-5.4-2.3-6c0,0,2.9,2.7,3.1,2.6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.8,168.7c0.1-0.2,3.3,3.3,3.5,3c0.2-0.3,1-3.9,1.1-4.1c0.2-0.2,3.8,3.9,4.2,3.5c4.2-5.1-11-8-7.5-12.2 c0.1-0.1,3.7,3.5,3.9,3.3c3.2-3.8-8.4-6.9-5.9-9.9c0.3-0.4,3.3,3.3,3.6,3c0.6-0.8-2-4.1-1.4-4.7c0.4-0.4,0.7,0.6,0.7,0.6 c0.5-0.6-2.3-3.4-1.4-4.5c0.1-0.1,3,2.9,3.2,2.7"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,155.8c1.4-1.7,6.4,10.5,8.9,7.5c2.7-3.2-9.4-9.3-8.5-10.5c0.1-0.1,3.5,3.2,3.7,3.1 c1.3-1.6-5.1-4.9-2.6-7.9c1.2,0.9,2.3,1.8,3.3,2.8"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66,157.4c0.2-0.2,3.3,2.8,3.3,2.8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69,161.9c0.1-0.1,3.2,3.1,3.4,2.8c2.3-2.7-7.2-5.6-5.2-7.9c0.8-0.9,4.7,4.7,5.1,4.3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.2,155.9c0.2-0.2,3.4,3.1,3.5,2.9c0.8-0.9-5.4-4.8-3-7.7c0.2-0.2,3.4,3,3.5,2.9c2-2.3-5.1-3.7-2.9-6.3 c0.1-0.2,3,2.7,3.1,2.6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.8,156.2c0.1-0.1,3.2,3,3.4,2.8c1.3-1.6-5.3-5.1-3.2-7.6c1.1,1,2.2,2,3.4,2.9c0,0-3.9-5-3.2-5.9 c1,1,2.1,1.9,3.2,2.7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.5,166.2c0.1-0.1,3.4,2.8,3.4,2.8c0.7-0.9-2.3-4.4-1.7-5c0.2-0.2,1.5,1.3,1.5,1.3c0.8-0.9-4.5-6.9-3.9-7.7 c0-0.1,3.7,3.9,4.1,3.4c1.7-2-3.4-4.9-1.8-6.8c0.2-0.2,3.2,3.5,3.6,3c0.4-0.5-5.6-6.1-3.5-8.6c0.1-0.1,3.1,3,3.3,2.8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,156c0.4-0.4,3.5,3.3,3.7,3.1c0.2-0.2-4-7.2-3.9-7.4c0.1-0.2,3.6,4,4.1,3.4c2.2-2.6-6.1-5.8-4.2-8.1 c0.5-0.6,3.9,3.7,4.1,3.5"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80,155.2c0.3-0.3,3.5,3.4,3.7,3.1c0.8-1-6.5-4.7-4-7.6c0.3-0.3,3.9,3.5,4,3.4c2.4-2.9-7.1-4.2-4.3-7.5 c0.6-0.7,3.9,3.9,4.2,3.5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,154.4c0.1-0.2,3.5,3.5,3.8,3.2c1.5-1.8-6.7-5.3-4.4-8.1c0,0,3.7,3.6,3.9,3.3c0,0-5.4-6-4.5-7.1 c0.1-0.1,3.8,4,4.2,3.5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.8,151.7c0.3-0.4,3.7,4.2,4.3,3.6c0.5-0.6-8.3-7.3-5.7-10.4c0.2-0.2,3.6,3.9,4,3.4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.3,143.5c0.1-0.1,4,3.5,4,3.4c1.6-1.9-2.7-5-2.5-5.2c0.4-0.4,3.6,3.6,3.9,3.3c1.3-1.5-2.1-5.6-1.5-6.4 c0.3-0.4,3.7,3.3,3.8,3.2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.1,138.8c0-0.1,3.2,3.2,3.4,2.9c1.3-1.6-3.3-3.9-2.1-5.4c0.5-0.6,4,3.8,4.2,3.6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.9,141.4C45,141.3,48,144,48,144c2.9-3.5-9.7-4.4-6.3-8.3c2.4-2.8,7.3,8.7,8.6,7.2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1,140.8c0.1-0.1,3.9,4.1,4.3,3.6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,149.2c0,0,3.7,4,4.2,3.5c1.8-2.1-3.9-5.2-2.3-7.1c0.2-0.3,3.6,3.7,3.9,3.3s-3.5-5.2-1.9-7.1 c0.2-0.2,3.8,4.2,4.3,3.6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.7,176.7c0-0.1,3,2.7,3.1,2.6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.3,155.5c0.1-0.2,3.2,2.9,3.3,2.8c0.7-0.9-6.1-4.1-3.9-6.8c0.3-0.3,3.6,3.2,3.7,3.1c2.3-2.7-6.5-4-3.9-7.2 c0.2-0.3,3.2,2.9,3.3,2.8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.1,151.6c1.1,1,2.2,2,3.4,2.9c0,0-4.3-5.3-3.5-6.2c1,1,2.1,1.9,3.3,2.8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,160.4c0.2-0.2,1.5,1.2,1.5,1.2c0.4-0.5-0.8-4.4-0.5-4.8c0,0,3.3,3.3,3.5,3c1.4-1.6-2-4.3-0.7-5.8 c0.1-0.2,3.2,3.1,3.4,2.9c0.4-0.5-6.1-6.4-4-8.9c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.3,160.3c0.1-0.2,3.5,3.4,3.7,3.1c1.8-2.2-9.7-5.6-6.8-9c0-0.1,3.8,3.7,4.1,3.4c0,0-4.9-5.7-4.1-6.7 c0,0,3,2.6,3,2.5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.9,169.7c0.5-0.6,2.6,2.4,2.7,2.3c0.9-1.1-6.2-7.4-5.5-8.3c0,0,3.5,3.6,3.8,3.2c3.4-4-11.3-8.2-8.1-12 c0.3-0.3,3.6,3.9,4,3.4c0.7-0.8-11.6-8.6-8.3-12.5c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.1,122.9c0.1-0.1,3,2.6,3,2.5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.1,131.2c0-0.1,3.5,3.1,3.6,3c1.1-1.4-7-7-5.7-8.5c0.1-0.1,3.9,3.9,4.2,3.5c2.4-2.8-4.5-6.2-3.2-7.7 c0.1-0.1,3.4,3.3,3.6,3c1.5-1.8-5.7-5.6-3.4-8.3c0,0,3.5,3.3,3.7,3.1c0,0-4.2-5.2-3.4-6.1c0,0,3,2.7,3.1,2.6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40,117.4c0.1-0.2,3.2,3.1,3.4,2.9c0.5-0.5-7.9-6.7-5.4-9.6c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.4,144.8c0.3-0.3,1.8,1.6,1.8,1.6c0.5-0.7-1.8-5.1-1.4-5.7c0,0,4.1,4.7,4.7,3.9c1.9-2.3-4.6-5.5-2.8-7.6 c0.4-0.5,4,4.5,4.5,3.8c0.4-0.4-4.1-5.5-2.4-7.6c0,0,2.9,2.5,2.9,2.4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.6,162.5c0.4-0.5,4.3,3.8,4.4,3.7c2.2-2.6-5.8-3.9-3.4-6.8c0.4-0.5,3.5,3.3,3.7,3.1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,157.1c0-0.1,3.8,3.7,4.1,3.4c0,0-7.5-7.2-6.4-8.6c0.2-0.2,5.1,6,5.9,5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,158.2c0.1-0.1,3.1,3,3.3,2.8c0.6-0.7-9.9-7.9-7-11.4c0.1-0.1,3,2.8,3.2,2.7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,178.8c0,0,3.1,2.9,3.3,2.8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.8,172.4c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.9,180.6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.4,176.2c0.2-0.3,3.2,2.9,3.3,2.8"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.3,181.7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.9,180.4"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,177.5c0.3-0.4,3.7,4.3,4.3,3.6s-9.3-7.7-6.5-11.1c0-0.1,3,2.8,3.2,2.7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.4,125.8c0,0,3.4,3.5,3.8,3.2c2.3-2.7-6.4-6.2-4.2-8.8c0.5-0.6,4.4,5.2,5.1,4.3c0.4-0.5-4.9-5.8-3-8.1 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.3,180.6"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.7,178.3c0.2-0.2,1.5,1.3,1.5,1.3c0.9-1.1-6-7.9-5.2-8.8c0,0,3.3,3.3,3.5,3c3.1-3.7-10-7.7-7.1-11.2 c0.2-0.2,3.4,3.4,3.7,3.1c0.6-0.7-10.4-8.1-7.3-11.7c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.8,180.2"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.5,177c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22,174.3c0,0,3.6,3.7,3.9,3.3c3.7-4.4-12.3-8.6-8.9-12.7c0.3-0.4,3.8,4.2,4.3,3.6c0.7-0.8-12.7-9.1-9.2-13.3 c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.6,177.5c0-0.1,3.4,3.4,3.7,3.1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.4,176.5c0.5-0.5,4.3,4.8,4.9,4.1s-10.1-8-7.1-11.6c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.3,170.2c0.5-0.6,3.7,3.6,3.9,3.3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.9,169.4c0-0.1,4,4,4.3,3.6c0,0-5.9-6.3-4.9-7.4c0.1,0,3.7,3.8,4,3.4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.8,170.1c0.4-0.4,3.9,4.4,4.5,3.8c0.5-0.6-8-7.2-5.5-10.2c0,0,2.9,2.6,3,2.5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.5,177.9c0.2-0.2,1.5,1.2,1.5,1.2c0.9-1.1-6-7.7-5.2-8.6c0,0,3.4,3.5,3.7,3.1c3.2-3.8-10.1-7.7-7.1-11.2 c0.2-0.2,3.3,3.3,3.6,3c0.6-0.7-10.8-8.3-7.7-12c0.1-0.1,3.3,3.3,3.6,3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,178.2c0,0,3.2,3.1,3.4,2.9c3.2-3.9-10.5-7.9-7.5-11.5c0.2-0.3,3.4,3.5,3.7,3.1c0.6-0.7-9.6-7.8-6.7-11.2 c0.1-0.1,3,2.8,3.2,2.6"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.4,177.2c0,0,3.7,3.5,3.9,3.3c0,0-6.1-6.4-5.1-7.5c0.1-0.1,3.8,4,4.2,3.5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.2,176.2c0,0,3.2,3.2,3.5,2.9c2.6-3.1-8.6-6.4-6.1-9.3c0.2-0.2,3.4,3.5,3.8,3.2c0.6-0.7-10.2-8-7.2-11.6 c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.4,175.2c0.2-0.2,3.3,3.3,3.6,3c0.6-0.8-11-8.4-7.8-12.2c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.6,113c0,0,3.3,3.2,3.5,3"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M37.5,124.3c0.2-0.1,1.3,1.1,1.3,1.1c0.5-0.7-2.8-5.7-2.3-6.3c0,0,3.1,3,3.3,2.8c2-2.4-5-5.7-3.2-7.9 c0.2-0.2,3.2,3.3,3.5,2.9c0.3-0.4-4.1-5.5-2.4-7.6c0,0,2.9,2.6,3,2.5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.5,178.4c0,0,2.9,2.6,3,2.5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.8,164.6c0,0,3.5,3.7,3.9,3.3c2.8-3.3-9.3-6.5-6.7-9.5c0.3-0.4,3.7,3.9,4.1,3.4c0.6-0.8-11.1-8.4-7.9-12.2 c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.1,157.2c0,0,3.2,3.2,3.4,2.9c2-2.4-5.4-5.4-3.5-7.6c0.3-0.3,3.6,3.9,4,3.4c0.4-0.5-5.1-5.9-3.1-8.2 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.4,149.2c0.1-0.1,5,5.3,5.5,4.6c0,0-5.7-6.1-4.7-7.2c0.1-0.1,4.2,4.7,4.8,4"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.2,148.3c0.1-0.2,3.3,3.3,3.5,3c0.5-0.6-9.5-6.2-7-9.3c0.3-0.4,4.4,5.3,5.2,4.4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.8,127.1c0,0,3.4,3.5,3.8,3.2c1-1.2-1.3-3.3-0.3-4.4c0.3-0.4,3.7,4,4.1,3.5c0.2-0.3-0.2-3.6,0.9-4.8 c0.1-0.1,3.3,3.2,3.5,2.9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.5,156.6c1,1,2,1.9,3.1,2.7c1.7-2.1-4.8-4.7-3.1-6.7c0.3-0.4,3.7,3.9,4.1,3.4c0.4-0.5-5.6-6.1-3.6-8.6 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.9,124.2c0,0,3.5,3.6,3.8,3.2c1-1.2-2.1-3-1.1-4.1c0.3-0.4,3.7,4.1,4.2,3.5c0.5-1.4,1.1-2.7,1.9-4 c0.1-0.1,3.1,3,3.3,2.8"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.3,143.6c0.3-0.3,3.6,3.8,4,3.3c0.6-0.7-9.8-7.3-7-10.6c0.3-0.4,4.4,5.3,5.2,4.4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.3,174c0.2-0.2,3.3,3.3,3.6,3c0.7-0.8-11.7-8.6-8.3-12.6c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.7,173.7c0.3-0.4,3.7,4.1,4.2,3.5c0.7-0.8-11.5-8.6-8.2-12.5c0.1-0.1,3.3,3.2,3.5,2.9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.4,141.7c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.7,147.3c0.2-0.3,3.4,3.5,3.7,3.1c0.5-0.5-9-6.6-6.4-9.6c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.4,151.1c0.4-0.4,3.9,4.3,4.4,3.7s-8.7-7.4-6-10.6c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.6,162.6c0.1-0.2,3.2,3.1,3.4,2.9c0.6-0.7-10.6-8.2-7.6-11.9c0.2-0.2,3.8,4.2,4.3,3.6"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,168.5c0.2-0.3,3.5,3.7,3.9,3.3c0.6-0.7-10.4-8.1-7.3-11.8c0.1-0.1,3.2,3.2,3.4,2.9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33,121.7c1,0.9,2,1.8,3.1,2.6c1.7-2.1-3.7-5-2.1-7c0.1-0.1,3,3.1,3.3,2.8c0.3-0.3-2.3-4.7-0.9-6.4 c0,0,2.9,2.6,3,2.5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.1,145.4c0.2-0.2,3.2,3,3.4,2.8c0.5-0.6-8-6.7-5.6-9.6c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,170.4c0.1-0.2,3.3,3.3,3.5,3c0.6-0.7-10-8-7.1-11.5c0-0.1,3.2,3.2,3.4,2.9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.1,150.3c0.2-0.3,3.4,3.9,3.9,3.3c0.5-0.6-8.3-7.3-5.7-10.4c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,176.4c0.5-0.6,4.5,5.5,5.3,4.5c0.5-0.6-8.5-7-5.9-10.1c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,163.1c0.2-0.2,3.2,3.2,3.5,2.9c0.6-0.7-9.9-7.2-7.1-10.6c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.1,170.3c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,178.9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.7,175.6c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.8,179.6"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.8,172.7c0.2-0.2,3.2,3.1,3.4,2.8c0.6-0.7-10.1-7.5-7.2-10.9c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,142.6c0.2-0.3,3.4,3.5,3.7,3.1c0.5-0.6-8.3-6.1-6-8.9c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.7,172.4c0.2-0.2,3.3,3.4,3.6,3.1c0.7-0.7-10.3-8.1-7.3-11.7c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.8,180.2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.6,158.2c0.2-0.3,3.3,3.6,3.7,3.1c0.4-0.5-7-5.2-5.1-7.5c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.1,173.1c0.4-0.5,4.1,4.6,4.7,3.9s-10-7.7-7.1-11.2c0.2-0.2,3.6,3.9,4,3.4"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,156.6c1,0.9,2,1.8,3.1,2.6c1.7-2.1-5.2-4.5-3.6-6.5c0.2-0.2,3.2,3.4,3.6,3s-5-5.9-3.1-8.1 c0,0,2.9,2.6,3,2.5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.1,172.4c0.1-0.2,3.1,3.3,3.5,2.9c0.4-0.4-6.1-4.6-4.4-6.7c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.6,173.9c0.1-0.1,3.1,3,3.3,2.8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.6,121.8c0.1-0.2,3.2,3.1,3.4,2.9c0.2-0.2-0.7-2.8,0.2-3.8c0.1-0.1,3.1,3,3.3,2.8"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,128c0.2-0.3,3.6,3.5,3.9,3.2c0.2-0.3-1.7-3.5-0.6-4.8c0.1-0.2,3.5,3.7,3.9,3.2"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.2,172.2c0.1-0.1,2.9,2.7,3,2.6c0.3-0.4-3.7-4.5-2.2-6.2c0-0.1,3,2.8,3.1,2.6"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.2,171.6c0.2-0.2,3.5,3.6,3.8,3.2c0.5-0.7-9.6-7.4-6.8-10.7c0.1-0.1,3.3,3.3,3.6,3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38,137.6c0,0,2.9,2.6,3,2.5c0.3-0.3-2.2-4.6-0.8-6.3c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.4,181.6"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.9,139.8c0.2-0.3,3.7,3.6,3.9,3.3c0.2-0.3-2.6-3.9-1.4-5.4c0.1-0.1,3.1,3,3.3,2.8"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,163.9c0.2-0.2,3.2,3.1,3.4,2.8c0.4-0.5-8.3-5.4-6.1-8.1c0.1-0.1,3.3,3.3,3.6,3"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.7,134.7c0.1-0.2,3.3,3.3,3.5,2.9c0.2-0.3-2.2-4.2-0.9-5.7c0.1-0.1,3.4,3.5,3.8,3.1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.2,168.1c0.2-0.3,3.5,3.9,3.9,3.3c0.5-0.6-8.9-5.9-6.5-8.7c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.7,133.2c0,0,2.9,2.4,2.9,2.4c0.3-0.3-2.1-4.1-0.9-5.6c0.2-0.2,3.6,3.9,4.1,3.4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.5,130.1c0.1-0.2,3.2,3.1,3.5,2.9s-1-3.2,0-4.3c0,0,2.9,2.6,3,2.5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.1,137.2c0.1-0.1,3,2.8,3.1,2.6c0.4-0.4-4.4-5.6-2.6-7.7c0-0.1,3.1,2.9,3.2,2.7"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.3,177.8c0.2-0.2,3.6,3.9,4.1,3.4"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.5,147.8c0.1-0.1,3.1,2.9,3.3,2.7c0.5-0.6-9.6-6.4-7-9.5c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,147.6c0.2-0.2,3.3,3.2,3.5,2.9c0.5-0.5-8.5-5.7-6.2-8.5c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.5,131.1c0-0.1,2.9,2.6,3,2.5c0.2-0.3-1.3-3.9-0.2-5.3c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.7,158.2c0.1-0.2,3.2,3.1,3.4,2.8c0.5-0.6-9-6.4-6.5-9.4c0.1-0.1,3.3,3.3,3.5,3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.7,160.1c0.1-0.1,3.2,3.1,3.4,2.9"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,145.3c0-0.1,3.2,3.2,3.4,2.9"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.3,174.2c0.2-0.2,3.2,3.4,3.6,3c0.4-0.4-5.9-4.9-4.1-7c0.1-0.1,3.1,3,3.3,2.8"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.1,138.4c0.1-0.1,2.8,2.7,3,2.5c0.2-0.2-1.6-3.3-0.6-4.5c0-0.1,3,2.8,3.2,2.7"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,174.2c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.3,179.8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.7,132.6c0.2-0.2,3.4,3.3,3.7,3.1c0.2-0.2-2.6-3.2-1.5-4.4c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,120.3c0.1-0.2,3.5,3.7,3.8,3.2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.2,167.5c0.2-0.2,3.4,3.7,3.8,3.2s-7.5-5.1-5.5-7.5c0-0.1,3.2,3.2,3.4,2.9"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.5,144.7c0,0,2.9,2.5,2.9,2.4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,169.5c0.1-0.1,3.1,2.9,3.2,2.7c0.4-0.6-6.6-6-4.5-8.5c0.1-0.1,3.3,3.4,3.6,3.1"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.3,170.2c0.2-0.2,3.4,3.3,3.6,3c0.2-0.3-3.2-3.4-2.1-4.7c0-0.1,3,2.8,3.2,2.7"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.3,178.5c0.1-0.1,3.3,3.3,3.5,2.9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,165.9c0.1-0.1,3.4,3.5,3.8,3.1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.3,141.4c0-0.1,2.9,2.6,2.9,2.5c0.2-0.3-1.5-4-0.4-5.4c0,0,2.9,2.7,3,2.6"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,135.2c0.1-0.1,3.3,3.3,3.6,3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.8,171.5c0.1-0.1,3,2.8,3.1,2.6c0.4-0.4-6.4-4.7-4.6-6.9c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.8,173c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.1,150.8c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.9,148.4c0.1-0.1,3.3,3.3,3.6,3"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.8,179.2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.5,157.8c0.1-0.1,3.2,3.1,3.4,2.9"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.1,130.4c0,0,2.9,2.7,3.1,2.6"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.1,168.1c0-0.1,3.2,3.2,3.4,2.9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.5,159.3c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.7,156.2c0.1-0.1,3.3,3.3,3.5,3"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.8,162.2c0-0.1,3.2,3.2,3.4,2.9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.7,167.6c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.3,158.5c0.2-0.1,3.3,3.3,3.6,3"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.3,146.9c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,167.8c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.2,165.1c0,0,2.9,2.6,3,2.5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.8,174.5c0-0.1,3.2,3.1,3.4,2.9"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,138.2c0-0.1,3.2,3.1,3.4,2.9"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.1,146.4c0.1-0.1,3,2.8,3.2,2.6"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.9,177.8c0.1-0.1,3.1,3,3.3,2.8"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.7,131.8c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.2,172.4c0-0.1,3.2,3.2,3.4,2.9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48,175.2c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.4,179.1"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.9,171.2c0-0.1,3.2,3.2,3.4,2.9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.7,180.1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,157c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87,179.7"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.2,180"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.2,163.1c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.1,132.6c0.1-0.1,3.3,3.3,3.5,3"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.2,153.7c0.1-0.1,3.3,3.3,3.5,3"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.7,158.5c0,0,2.9,2.6,3,2.5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,181.3"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,180.9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.8,179.9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,151.4c0.1-0.2,3.6,3.8,4,3.3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.9,134.3c0.1-0.1,3.3,3.4,3.6,3.1"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.3,139.5c0.1-0.1,3.3,3.4,3.6,3"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5,159.5c0.2-0.2,3.8,4.2,4.3,3.6"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92,148.6c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.1,178.6c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,168.3c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.5,173.2c0-0.1,3,2.8,3.1,2.6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.7,172.7c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.3,141.4c0,0,2.9,2.7,3,2.5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.6,163.6c0.1-0.1,3.1,3,3.3,2.8"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.2,146.3c0-0.1,3,2.8,3.1,2.6"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.1,145.1c0-0.1,3,2.8,3.2,2.6"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33.7,117.6c0,0,3,2.7,3.1,2.6"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.4,158.8c0,0,2.9,2.6,3,2.5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.7,7.4c0.1-0.1,3.5,3.2,3.6,3.1c0.6-0.7-1.4-2.5-0.2-3.9c0.5-0.7,5.3,4.7,5.4,4.5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.4,4.3c0.1-0.1,3,2.7,3.1,2.6C63.2,6,61.9,3.5,62.3,3c0.1-0.1,3,2.5,3,2.5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,4c0.3-0.4,3.5,3.2,3.6,3"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.8,11.1c0.1-0.1,2.9,2.6,3,2.5c0.7-0.8-3-3.7-1.7-5.2c0.7-0.9,4.4,4,4.5,3.8c0.4-0.5-2.7-4.2-1.8-5.2 c0.5-0.6,3.7,4.1,4.2,3.5c0.8-1.1-1.3-4.1,0-5.6c0.8-1,5.3,5.7,5.9,5c0.6-0.7-2.7-4.1-0.8-6.3c0.6-0.7,4.9,4.5,5.1,4.3 c1-1.1-0.6-2.1,0.6-3.4C69.3,3.8,72.6,8.4,73,8"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.6,3C68.7,2.8,74,8.8,74.6,8c0,0-3.6-4.9-2.9-5.7c0-0.1,3.3,3.2,3.6,3"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.2,10.2c0.2-0.2,1.5,1.2,1.5,1.2c0.7-0.8-3.6-6.3-3-7c0.1-0.1,6.4,8.7,8,6.7c1-1.2,0.6-2.8,1.6-3.9 c0.3-0.4,3.8,4.2,4.3,3.6c0.2-0.2,2.7-1.4,3.7-2.5c0-0.1,3,2.8,3.1,2.6"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,22c0.1-0.1,3.6,3.7,3.9,3.3"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.5,27.1c0.2-0.2,3.3,3.4,3.6,3c0.7-0.8-12-8.8-8.6-12.8c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,1.5c0.3-0.4,3.8,4.3,4.4,3.7c0.2-0.2,2.6-0.8,3.5-1.8c0.2-0.2,3.8,4.3,4.3,3.6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.2,2.1c0.2-0.3,3.5,3.7,3.9,3.3c0.1-0.2-1-2.4-0.3-3.2C69,2,72.2,5.4,72.4,5.1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M67.2,1.9c0-0.1,2.9,2.5,2.9,2.5c0.4-0.9,0.9-1.8,1.5-2.7c0.1-0.1,3,2.8,3.2,2.7"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.3,5.8c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.2,100.1c0.2-0.2,3.1,3,3.3,2.7c0.7-0.8,1.3-2.5,2.3-3.7c0.1-0.2,3.3,3.1,3.4,2.9c0.9-1-6.8-5.6-4-9 c1.8-2.1,8.8,8.5,9.4,7.9c3-3.5-9.3-4.8-5.9-8.8c3.2-3.8,8.9,10.8,10.5,8.8"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.5,71.2c0.1-0.1,3.2,3,3.3,2.8c0.5-0.6,0.5-1.8,1.2-2.8c1.1,1,2.2,1.9,3.3,2.8c0,0-0.9-3.2-0.5-3.7 c0.1-0.1,3.7,3.8,4.1,3.4"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M93.9,107.9c0.1-0.1,2.8,2.8,3,2.5c0.2-0.3-3.5-6.5-3.3-6.8c1.4-1.7,6.2,6,6.6,5.6c3-3.5-9.4-6.6-7.1-9.3 c3-3.6,9.3,11.8,11.3,9.5c2.6-3.1-18.7-8.2-13.5-14.4c3.5-4.2,8.6,16.9,13.3,11.2c0.1-0.1-4.8-6.2-3.9-7.2c0.6-0.7,6.2,5.8,6.5,5.4 c3.3-4-6.6-8.4-5.7-9.5c1.3-1.5,5.9,6.8,6.8,5.7c0.7-0.9-7.9-7.6-5.9-10c1-1.2,6.9,6,7,5.9c0.1-0.1-7-8.2-5.5-9.9 c1.1-1.3,5.6,5.5,6,5c0.2-0.2-6.5-5.4-4.9-7.2c0.6-0.8,4.5,5.7,5.5,4.5c1.4-1.7-5.8-6.7-4-8.8c0.3-0.4,5.2,4.5,5.3,4.4 c1.3-1.5-4.3-7.4-3.5-8.4c0.8-1,3.9,3.6,4.1,3.4c1.3-1.6-10.1-10.6-8.9-12c0.1-0.1,7.8,11.3,10.2,8.6c2.9-3.5-9.1-7.3-6.4-10.6 c0.6-0.7,4.8,6,5.8,4.8c0.6-0.7-10-8-7.1-11.5c0.1-0.2,3.5,3.8,4,3.3"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.6,99.3c1.4-1.6,5.4,5.9,6.1,5.1"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.4,104.9c0.5-0.6,5.3,6.2,6.2,5.2c2.4-2.9-12.3-7.2-8.6-11.6c0.1-0.2,7.1,8.2,8.2,6.9c0,0-4.7-5.5-3.9-6.5 c0-0.1,3.4,3.3,3.6,3.1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84,124.8c1.1,0.8,2.2,1.7,3.2,2.7c0-0.1-2.5-4.7-1.9-5.5s4.6,4.2,4.8,4s-4.7-4.5-3.5-6 c0.6-0.7,4.2,5.7,5.3,4.5c1.1-1.3-3.3-5.5-1.9-7.1c0.2-0.3,4.4,3.8,4.4,3.7c1-1.3-3.2-6.5-2.4-7.4c1-1.2,4.5,4.2,4.7,3.9 c1-1.2-6.9-8.5-6-9.5c0.1-0.1,7.4,10.8,9.7,8.1s-6.2-6.1-4.1-8.7c0.8-0.9,5.2,6.8,6.4,5.4c0.3-0.4-4.1-5.5-2.4-7.6 c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.5,124.6c1.4-1.7,7.8,7.4,8.2,6.9c1.9-2.2,4.3,4,6.4,1.5c1.8-2.2,6.3,7.2,7.2,6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.3,137.9c0.2-0.2,5.5,6.7,6.5,5.4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.4,151.2c0.1-0.1,3.1,3,3.3,2.8c1.1-1.3-21.8-11.4-16.5-17.8c1.1-1.3,8.8,13.5,11.8,9.9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M114.4,63.3c0.1-0.1,3.7,3.8,4.1,3.4"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109.8,83.9c0.4-0.5,3.8,4.5,4.5,3.7c1.1-1.3-3.3-5.5-1.9-7.1c0.2-0.2,3.9,3.3,3.9,3.3c0.9-1.1-2.1-5.8-1.4-6.6 c0.3-0.4,1.9,1.7,1.9,1.6c0.9-1.1-5.6-7.6-4.8-8.5c0,0,4.6,5.5,5.4,4.5c2.1-2.5-5.5-5.8-3.5-8.2c0.2-0.3,3.6,3.7,3.9,3.3 c0.3-0.4-3.7-5.3-2-7.3c0.1-0.1,3.4,3.5,3.8,3.2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108,88.9c0.3-0.4,3.8,3.8,4.1,3.4c0.3-0.4-3.1-5-1.6-6.9c0.1-0.1,3.3,3.3,3.5,3"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.3,177.2c0,0,2.9,2.7,3,2.6"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,123.4c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.6,177.8c0,0,2.9,2.6,3,2.5"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.5,173.8c0.1-0.1,3.1,3,3.3,2.8"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.3,172c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.2,175.2c0-0.1,3,2.8,3.1,2.6"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M130.3,169.1c0,0,2.9,2.6,3,2.5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.7,104.2c0.5-0.7,4.3,4.2,4.6,3.9"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.2,122.4c0.6-0.7,5,4.6,5.2,4.4c1-1.2,2.1-1,2.7-1.7c0.3-0.3,3.3,3.1,3.5,2.9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58,114.6c1-1.1,0,2.2,1.1,0.9c2-2.3-3.5-4.6-2.3-5.9c0,0,7.9,9.1,9.1,7.6c0.3-0.3-7-5-4.3-8.3 c0,0,3.3,3.2,3.5,3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.7,109.9c0.2-0.2,3.4,3.5,3.8,3.2c0.5-0.6-4.3-6.3-3.6-7.1c0.2-0.3,4.8,6.1,5.8,4.8"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.9,98.9C42,98.8,42,99,42,99c0.6-0.7-3.1-3.8-2-5.1c0.5-0.6,4.9,7,6.3,5.3"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.5,91.5c0.2-0.2,3.6,3,3.6,3"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.1,72.5c0.4-0.4,3.5,3.5,3.8,3.2c1.7-2-5.8-6.2-4.9-7.2c0.1-0.1,3,2.6,3,2.6"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.1,78.9c0.1-0.1,3.2,3.1,3.4,2.8c2.6-3.1-7.9-6.6-5.7-9.3c0.5-0.6,3.9,3.7,4.1,3.4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.1,77.2c0.1-0.1,3.1,2.6,3.1,2.6c1.9-2.3-5-3.7-2.9-6.3c0.3-0.3,3.3,3,3.4,2.8"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.1,82.4c0.1-0.1,3.5,3.5,3.8,3.2"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48,103.9c0.7-0.9,4.8,6.4,6,5c3.1-3.7-18.2-11.3-14.2-16.2c1.1-1.3,10.9,9.7,11.2,9.4 c2.6-3.1-13.4-12.7-11.5-15c1.7-2,7.2,6.7,7.5,6.3c1.2-1.4-8.7-9.7-7.7-10.9c0.1-0.1,6.9,9.6,8.8,7.4c3.7-4.4-12.4-8.6-9-12.8 c0.9-1,5.5,7.2,6.8,5.7c0.5-0.7-8.9-7.5-6.2-10.8c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.1,71.6c0,0,3.2,3.1,3.4,2.9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.6,86.5c0.2-0.2,1.6,1.4,1.6,1.4c0.9-1.1-6.2-8.1-5.4-9c0-0.1,5.9,7.9,7.3,6.1c4.7-5.6-16.7-10.3-12.3-15.6 c1.5-1.8,7.6,11.1,10,8.4c0.7-0.9-14-9.6-10.2-14.1c0.2-0.2,3.9,4.4,4.4,3.7"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.1,96.3c0.2-0.2,3.5,3,3.5,2.9c2-2.4-5.4-3.8-3.1-6.5c0.1-0.1,3,2.6,3,2.5"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.9,86.6c0-0.1,4,4.4,4.5,3.9"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.5,92.6c0.2-0.3,1.6,1.4,1.6,1.4c1.3-1.5-9.2-10.1-8.1-11.3c0,0,3.8,4.2,4.3,3.7c2.9-3.5-9.1-7.3-6.4-10.6 c0.2-0.2,3.4,3.4,3.7,3.1c0.5-0.6-7.3-6.9-4.9-9.7c0,0,2.8,2.3,2.8,2.3"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.1,5.9c0,0,3.1,2.7,3.2,2.6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112,45.3c0,0,3.1,2.8,3.2,2.7"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.8,47.2c0.3-0.3,3.6,3.2,3.7,3.1c1.3-1.5-4.3-5.5-3.2-6.7c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105.7,44.9c0.7-0.9,4.6,4.2,4.8,4c2.4-2.9-6.9-4.7-4.6-7.5c0.1-0.1,3.6,3.6,3.9,3.3c1.8-2.1-6.1-4.7-4-7.2 c0.1-0.1,2.9,2.6,3,2.5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.5,62.7c0.2-0.2,4.4,5.1,5.1,4.3c2-2.4-9.4-9.7-8.2-11.2c2.8-3.3,9.1,9.2,9.9,8.3c1.2-1.5-8.4-4.6-5.6-7.9 c3.1-3.8-2.2,4,0.7,0.6c0.1,0-5.9-5.8-3.4-8.8c1.9-2.3,9.7,10.6,10.9,9.2c0.3-0.4-10.7-6.5-7.8-9.9c1.2-1.5,6,8.6,7.8,6.5 c2.2-2.6-4.9-6.5-4.5-7c0.4-0.5,4.2,3.6,4.2,3.6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.6,39.3c1.1,0.8,2.2,1.7,3.2,2.6"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M108.8,47.2c0.2-0.2,3.1,2.9,3.2,2.7c1.2-1.5-2.7-5.8-1.5-7.2c0.6-0.6,2.9,3.4,3.4,2.8c0.2-0.2-6.4-5.4-4-8.3 c1.1-1.3,5.1,5.1,5.5,4.6"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.8,3.5c0.5-0.5,3.8,4.4,4.4,3.7c1-1.2-1.7-3.3-1.1-3.9c2.1-2.5,6.7,9.1,8.4,7.1c0.3-0.3,0-4,0.1-4.2 c0.1-0.2,4.9,5.2,5.5,4.5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M113.5,30.4c0.3-0.3,3.8,4.8,4.6,3.9c1.4-1.6-9.8-7.6-7.7-10.1c0.1-0.1,3.2,3,3.4,2.8"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.3,45.6c0.3-0.4,3.3,3.5,3.6,3.1c0,0-4.8-6.4-3.1-8.5c0-0.1,3.9,3.4,4,3.3c0.6-0.8-5.7-8.8-5.1-9.6 c0.4-0.5,3.9,3.6,4,3.4c1.4-1.6-7.8-4.5-5.3-7.5c0.2-0.3,3.5,3.7,3.9,3.3"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.8,24.8c1.5-1.8,6.5,10.1,8.8,7.4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M110.4,35.9c0.6-0.8,5.7,6.1,6.3,5.3c2.5-2.9-10.4-5.8-6.5-10.4c0.6-0.7,4.3,5.3,5.1,4.3 c3.3-3.9-10.6-8.6-8.1-11.6c1.1,0.8,2.2,1.7,3.1,2.6"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.3,23.9c0.1-0.1,3.3,3.1,3.5,2.9c1.6-1.9-2.9-3.7-1.2-5.7c0,0,3.4,2.9,3.4,2.9c1.3-1.6-2.2-3.1-0.8-4.8 c0.5-0.6,4,3.5,4.1,3.4"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.1,16.9c0,0,3.4,3.1,3.5,3"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.8,61.8c0.1-0.2,3.9,3.7,4.1,3.4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.1,49.6c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.9,41.6c0.5-0.6,4,3.8,4.2,3.5c0.9-1.1-3.7-6.2-3.1-7c0.5-0.6,4.1,4.7,4.7,4"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.3,34.1c0.3-0.4,3.4,3.7,3.8,3.2"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39,39c4.4-5.3,5.6,4.8,5.7,4.8"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.4,30.6c0.2-0.3,14,13.2,14.7,12.3"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35.7,23.6c0.2-0.3,5.1,5,5.5,4.6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M38.2,26.9c2.5-3,6.9,9.7,8.8,7.4c0.2-0.3-15.9-6.3-10.6-12.5c1.4-1.6,10.3,12,11.9,10"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.8,44.3c0,0,2.9,2.4,2.9,2.4c0.5-0.6-3.2-4.9-2.3-6c0,0,3.2,2.7,3.2,2.7c0.5-0.6-17.5-9.5-12.2-15.8 c2.4-2.9,13.1,11.9,13.6,11.3c0.5-0.6-5.1-6.3-4.3-7.3c0.8-1,5.7,6.7,6.6,5.6"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.8,36.2c0.3-0.3,3.5,3.2,3.7,3.1c1.1-1.3-9.3-5.9-6.9-8.9c1.4-1.7,6.2,8.3,7.7,6.5"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.7,20.5c1.5-1.8-0.1,3.1,1.5,1.2"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.7,38.5c0.1-0.1,3.1,2.6,3.1,2.6c0.9-1.1-3.3-4.3-1.7-6.2c0,0,2.9,2.5,2.9,2.5c2.1-2.5-5-6.2-3.5-7.9 c4.4-5.2-4.1,7.9,1.5,1.2c2.3-2.7-8.3-8.7-6.8-10.5c3.9-4.6,8.2,14.9,12.1,10.2"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.3,15c0,0,3.4,2.8,3.4,2.8"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.8,14.7C45.2,11.8,53,27.4,55,25c4.2-5-10.6-11.3-10.3-11.7c1.2-1.4,10.9,11.3,11.9,10"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.7,21.5c0.1-0.1-2.1,4.9,1.1,1c1.3-1.6,3.5-0.5,4-1.1c0.2-0.2,3.6,3.4,3.8,3.2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M37.2,76.3c0.2-0.2,3.2,2.9,3.3,2.8c1.7-2-5-5.9-4.1-6.9c0.1-0.1,4,5.1,4.8,4.1c1.3-1.6-13.2-5.9-9.1-10.8 c1.4-1.8,8.9,8.4,9.4,7.9c0.5-0.6-7.2-9.5-6.1-10.7c2.5-3,3.3,4.3,4,3.4c5-6-14.3-9.7-11-13.6c0.7-0.9,14,14.8,15.5,13 c5.6-6.7-16.8-7.1-11.5-13.5c1-1.2,10.7,11.5,11.9,10c5.2-6.1-14-9.1-11.2-12.5c2.3-2.8,6,15.2,11,9.2c3.1-3.6-20.3-7.5-13.8-15.3 c1.2-1.4,5.9,9.3,8,6.7c0.4-0.4-7.4-7-5.2-9.7c2.2-2.7,13.1,16.2,15.7,13.2c0.1-0.1-7.2-6-4.8-8.9c1.2-1.5,6.5,6.1,6.8,5.7 c1.7-2-7.9-4.8-5.4-7.8c1.6-1.9,6.9,6.3,7.1,6c3.3-4-7.3-6.7-5.1-9.3c1.3-1.5,6.6,6.6,7.2,6c1.3-1.6-4.5-6.7-3.5-7.9 c0.3-0.4,5,4.4,5.1,4.3c1.3-1.6-3.1-7.6-3-7.8c0.1-0.1,4.3,4.6,4.8,4c0.1-0.1-5.8-4.1-3.9-6.4c0.7-0.9,4.4,4,4.5,3.8 c1.6-1.9-3.8-6.5-3.4-7c0.4-0.4,4.6,4,4.6,3.9c0.2-0.3-4.3-5.1-2.4-7.3c0.1-0.1,3,2.6,3,2.6"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M55.5,25.1c0.5-0.7,1.3,1.8,1.7,1.4c0.3-0.4,0.5-4.1,0.5-4.2c0.1-0.1,2.9,2.5,2.9,2.4"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.2,12.9c1.5-1.8,10.3,14.7,13.2,11.1c0.6-0.7-2.4-4-1.6-4.9c0.1-0.1,2.9,2.7,3.1,2.6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.1,11.2c0.1,0,3.2,3.3,3.5,2.9"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.5,9.4c0.1-0.1,3.2,2.7,3.2,2.7"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.6,14.1c0.7-0.8,0,5.1,2.5,2.1c1.4-1.7-2.1-3.5-1.1-4.8c0.6-0.7,8,11.4,10.3,8.6c0.2-0.2-10.1-6.9-7.8-9.7 c1.5-1.8,7.4,12.4,10.4,8.7c3.1-3.6-10.7-6.9-8.2-9.9s9.8,12.4,11.8,10c3.4-4-9.7-8.9-7.6-11.5c1.7-1.9,10.9,11.1,11.9,10"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.9,7.9c2.3-2.8,10.7,12.2,12.3,10.3"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63.2,6.6c0.2-0.3,3.7,3.2,3.7,3.1c-0.3-1.2-0.5-2.5-0.6-3.8c0.2-0.2,3.2,3.1,3.4,2.9"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69,8.3c0.2-0.2,3.1,2.7,3.2,2.6c0.3-0.8,0.7-1.5,1.1-2.2c0.1-0.1,3,2.7,3.1,2.6"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.8,9.3c0,0,2.9,2.5,2.9,2.4"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.4,7c0.2-0.2,3.1,3,3.3,2.7c0.9-1,6,1,6.4,0.5c0.4-0.5,5.6,8.7,7.6,6.4"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.8,14.2c0.1-0.1,3.3,2.8,3.3,2.8"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58,28.5c1.1,1.1,2.4,2.1,3.6,3c2-2.4-2.9-5.3-2.4-5.9s4.8,4.5,5.1,4.3S62.6,24,63,23.5c0.5-0.5,4.8,4.1,4.8,4 c2-2.4-2.9-5-2-6.1c0.6-0.7,6.2,5.2,6.2,5.2c1.6-1.9-5.5-8-5-8.5c0.1-0.2,8.2,7.7,8.6,7.2c2.9-3.5-8.1-5.7-5.1-9.3 c1-1.2,9.1,8,9.3,7.8c1-1.1-8-5.5-5.2-8.9c1.5-1.7,6.5,7.8,7.6,6.4c2.4-2.9-9.6-5.2-6.4-9c1.4-1.7,8.3,8.3,8.9,7.5"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.4,9.9c0.1-0.1,3.5,3.7,3.9,3.2c1-1.2-1.1-3.4-0.9-3.7c0.7-0.8,4.7,4.8,5.1,4.3"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.7,9.7c0.3-0.4,3.4,3.2,3.6,3"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.9,21.5c0.7-0.8,4,4.5,4.5,3.8c1.6-1.9-4.4-3.9-2.4-6.1c0.3-0.4,5.6,4.9,5.7,4.8c0.3-0.4-10.2-10.2-9.4-11.1 c1.9-2.3,4.1,8,6.4,5.3c3.2-3.8-7.3-6.6-5.6-8.6c0,0,5.7,6.2,6.4,5.4c0.1-0.2-2.2-3.4-0.6-5.2c0,0,5.5,6.7,6.5,5.5"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80.4,14.2c2-2.4,10,14.9,13.2,11.1c0.9-1-8.6-9-7.5-10.3c0.5-0.6,7.5,11.2,9.9,8.3"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91,23.6c0.1-0.1,2.9,2.7,3.1,2.6c0.4-0.4,1.1-2.2,1.3-2.4c0.2-0.3,0.4,0.3,0.4,0.3c1.4-1.6-10-6.9-7.5-9.8 c1.1-1.3,7.6,12.8,10.8,9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.7,9.8C86.2,8,97,22.9,98.4,21.2c1.4-1.7-7.7-4.4-4.9-7.8c1.8-2.1,1.9,2.2,2.2,1.8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M96.5,21.5c0.1-0.1,3.4,2.9,3.4,2.9c1.8-2.2-3.6-5.7-3.4-5.9c0.9-1.1,4.8,5.4,5.4,4.5c1.2-1.3-1.4-5.3-0.9-5.9 c0.5-0.6,4.4,4,4.5,3.8"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.3,16.9c0.1-0.1,3.4,3.6,3.8,3.2c1.5-1.8-4.4-4.1-3.1-5.8c0.2-0.3,3.3,3,3.4,2.9"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.8,6.3c0.6-0.7,3.9,3.9,4.2,3.5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M92.6,6.9c0,0,3,2.7,3.1,2.6"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.6,8.1c1.3-1.6,7.1,10.2,9.2,7.7c0.2-0.3-1.8-3.8-0.6-5.1c0.1-0.2,3.5,3.7,3.8,3.2"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,48.6c0,0,3.2,2.7,3.2,2.7c0.7-0.9-3.7-4.8-2.9-5.7c0.1-0.1,3.7,3.6,4,3.3c2.4-2.9-4.7-6.4-3.4-7.9 c0.2-0.1,3.4,3.2,3.6,3c1.2-1.5-4.2-5-2.3-7.3c0,0,3.5,3.4,3.8,3.2c0,0-2.2-4-1.7-4.7c0,0,3,2.7,3.1,2.6"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,34.9c0,0,3.3,3.3,3.6,3c1.8-2.2-4.2-5.3-2.5-7.3c0.1-0.1,3.1,2.9,3.3,2.7c0.3-0.4-3-5-1.5-6.8 c0,0,2.9,2.6,2.9,2.5"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,16.2c0,0,2.9,2.5,2.9,2.4"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,20.2c0-0.1,3.1,2.9,3.2,2.7"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,18.1c0,0,2.9,2.5,2.9,2.5"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,22.3c0,0,2.9,2.4,2.9,2.4"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.1,66.4l2.9,2.4c2-2.4-5.6-5.5-3.7-7.8c0.1-0.1,3,2.7,3.1,2.6c0.4-0.5-5.2-6-3.3-8.3c0-0.1,3,2.8,3.2,2.6"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.9,53.7c0,0,2.9,2.5,2.9,2.4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,49c0.1-0.1,3,2.8,3.2,2.6"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.2,46.4c0.2-0.2,3.4,3.6,3.8,3.2s-4.5-5.7-2.7-7.8c0,0,2.9,2.6,3,2.5"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4,47.5c0,0,2.9,2.5,2.9,2.4c0.4-0.4-4.6-5.7-2.7-7.9c0,0,2.9,2.5,2.9,2.4"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.1,59.5c0.2-0.2,3.1,3.2,3.4,2.8c0.3-0.4-5.2-4.6-3.5-6.6c0,0,2.9,2.7,3,2.5"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.8,38c0-0.1,2.9,2.6,3,2.5c0.3-0.4-5.3-4.5-3.7-6.4c0,0,2.9,2.6,2.9,2.5"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,54.4c0,0,2.8,2.3,2.8,2.3"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,41.2c0.1-0.1,3,3,3.2,2.7c0.2-0.3-3.8-3.7-2.5-5.2c0,0,2.8,2.4,2.8,2.4"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,50.9c0,0,2.9,2.4,2.9,2.4"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M114.7,75.2c1,0.9,2,1.8,3.1,2.6c2-2.3-5.4-5.3-3.5-7.5c0.5-0.6,4.4,5.3,5.2,4.4c0.4-0.4-4.1-5.5-2.4-7.6 c0,0,3,2.7,3.1,2.6"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.4,60.1c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.1,176.9c1-1.1,4.4,4.1,4.7,3.9c1.1-1.3-7.9-9.2-7-10.3c0-0.1,6,8.1,7.5,6.3c3.3-4-10.9-8-7.8-11.7 c0.9-1.1,5.6,7.5,7,5.9c0.5-0.6-6.8-6.7-4.5-9.4c0-0.1,3,2.8,3.1,2.6"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.3,181.5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1,162.2c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,126.5c0,0,3,2.7,3.1,2.6"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,124.2c0-0.1,3,2.7,3.1,2.6"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.3,167.3c0.1-0.1,3,3.1,3.3,2.8c0.3-0.3-3.3-4.4-1.9-6.1c0.1-0.1,3.6,3.9,4,3.4"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.4,168.9c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2,174.1c0.1-0.1,3.3,3.3,3.5,3"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.6,170.5c0-0.1,3.2,3.1,3.4,2.9"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,171c0,0,3,2.7,3.1,2.6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,180"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.9,174.5c0.5-0.5,4.2,4.9,4.9,4.1c0.7-0.8-11.9-8.7-8.5-12.7c0.1-0.1,3.3,3.3,3.5,3"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,173.4c0.1-0.2,3.2,3.2,3.5,2.9c0.6-0.7-9.8-7.3-7-10.8c0.2-0.2,3.7,4.1,4.2,3.5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.3,175.6c0.1-0.2,3.3,3.3,3.5,3c0.5-0.6-8.8-6.5-6.3-9.4c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,176.3c0.1-0.2,3.1,3.2,3.4,2.9c0.3-0.4-5.3-4.2-3.7-6.1c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.7,179.3"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,180.5"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.8,171.9c0.1-0.1,3.1,3,3.3,2.8"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.4,173.9c0.1-0.1,3.3,3.4,3.6,3.1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,178c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.5,177.7c0.1-0.1,3.1,3,3.3,2.8"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,170.1c0,0,2.9,2.7,3,2.6"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.4,164.7c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,165.2c0,0,3.3,3,3.4,2.9c1.6-2-3.2-4-1.9-5.6c1.3-1.5,5.1,6.9,6.4,5.4c0.9-1.1-4.1-5.5-3.4-6.4 c1.6-2,4.1,3.5,4.1,3.4c0.9-1.1-5.7-5-4.1-6.9c0.5-0.6,5,7.2,6.5,5.5"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,157.9c0.1-0.1,3.2,2.8,3.2,2.7c1.2-1.5-6.7-3.8-4.3-6.7c0.4-0.5,4.8,4.2,4.9,4.1"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.7,147.4c0.2-0.2,3.3,2.9,3.4,2.8"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,144c0.3-0.4,3.6,3.3,3.7,3.1"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,136.9c0.3-0.3,3.3,3,3.4,2.8"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,140.2c0.1-0.2,6.4,7.2,7.3,6.1c0,0-6.7-6.7-5.7-8c0,0,3.2,3.1,3.4,2.9"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.8,166.9c0.2-0.2,3.2,3.1,3.4,2.8c0.9-1.1-2.8-4.8-1.6-6.2c0.1-0.1,3.1,2.6,3.1,2.6 c2.3-2.8-11.4-11.5-9.6-13.5c1.7-2.1,7.4,7,7.8,6.5c1.2-1.5-9.1-10-8.1-11.2c0.1-0.1-2.9,3.7,0.1,0.1c1.4-1.6-1.9-4.2-0.6-5.7 c1.9-2.3,8.9,13.3,11.8,9.9c0.6-0.7-10.9-8.3-7.8-12.1c0,0,3,2.7,3.1,2.6"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107,151.7c0.1-0.2,3.2,3.2,3.4,2.9c0.4-0.5-6.8-6.5-4.5-9.2c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.6,125.5c0.1-0.1,3.6,3.9,4,3.4"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,146.4c1,0.9,2,1.8,3.1,2.6"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,148.9c0.1-0.1,3.1,3,3.3,2.8c0.3-0.4-5.7-4.4-4.1-6.4c0.1-0.1,3.1,3,3.3,2.8"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.6,145.1c0.2-0.2,3.3,3.2,3.5,2.9c0.4-0.5-7.2-5.1-5.2-7.6c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,139.1c0.1-0.1,3.3,3.3,3.5,3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,141.7c0.1-0.1,3.2,3.2,3.4,2.9"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.4,152.9c0.1-0.2,3.2,3.3,3.5,2.9c0.3-0.4-5.1-4.3-3.5-6.1c0.1-0.1,3.1,3,3.3,2.8"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.4,163.2c0.1-0.1,3.3,3.3,3.5,3"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.1,168.7c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,159.2c0.1-0.1,3.1,2.8,3.2,2.7"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.4,152.1c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.7,156.5c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.7,150.8c0,0,3.6,3.8,4,3.3c1.8-2.1-3.9-5.2-2.3-7.1c0.2-0.3,3.6,3.8,3.9,3.3c0.3-0.5-3.7-5.3-2-7.3 c0.2-0.2,3.7,4,4.1,3.5"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.3,108.6c0.2-0.2,3.9,4.9,4.7,3.9"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.1,105.6c0.4-0.5,3.7,4.2,4.2,3.6c0.1-0.1-0.5-2.6,0.8-4.1c0.2-0.2,4.2,4,4.4,3.7c0.8-1-0.9-3.4-0.1-4.4 c0.3-0.3,4.4,3.8,4.5,3.8"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.3,101.6c0.1-0.1,3.2,2.7,3.2,2.7"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.4,103c0.1,0,3.2,3.1,3.4,2.8c1.3-1.5-2.1-4-1.7-4.4c0.1-0.1,3,2.7,3.1,2.6"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.3,107.1c0.3-0.4,3.6,3.3,3.7,3.1c1.1-1.3-1.6-3.5-0.6-4.7c0.2-0.2,3.6,3.1,3.6,3c2-2.3-2.3-4.9-1.1-6.3 c0.2-0.2,3.1,2.8,3.2,2.7"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.9,118.8c0.7-0.9,8.2,7.4,8.5,7.1c0.2-0.3-7.8-8.5-7.2-9.2c2.5-3,6.4,11.2,9.3,7.8c1.7-2.1,4.7,1.9,5.6,0.8 c0,0,4.1,4.1,4.4,3.7c0.1-0.1-0.7-2.7,0.6-4.2c1,0.9,2,1.8,3.1,2.6"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.4,120.2c1,0.9,2,1.8,3.1,2.6"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.7,104.9c1.2-1.4,2.9,2.4,2.9,2.4c1-1.2-7-5.6-5.2-7.8c0.7-0.9,5.9,9.2,8,6.7"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.5,107.6c0.2-0.3,4.2,3.9,4.4,3.7c2-2.4-12.5-5.3-8.4-10.1c3-3.6,7.8,7.6,8.3,7"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.3,113.4c0.8-0.9,6.9,11.4,9.7,8.1c2.2-2.6-22-10.2-15.2-18.4c6.4-7.6,8.4,15.9,12.7,10.7 c0.2-0.2,4,0.6,5-0.6c0.7-0.9,4.2,4.4,4.6,3.9c0.7-0.8,0.8-2.8,1-3c0,0,2.9,2.5,2.9,2.5c1.1-1.3-1.1-3.7-0.9-3.9 c0.4-0.4,3.6,3.7,3.9,3.3c1.4-1.6-2.5-5.9-1.8-6.7c0.1-0.2,3.2,2.7,3.2,2.7"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.8,101.2c1.7-2-0.6,15.2,7.1,6c1.2-1.4-1.5-3.7-0.5-4.9c0.5-0.6,4.1,3.9,4.3,3.6"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.1,93.2c6.6-7.9,2.1,5.2,3.8,3.1c0.5-0.6,4.9,2.3,5.7,1.2c0.4-0.5,3.5,3.9,4,3.4c0.9-1.1-1.4-4,0-5.7 c1.4-1.7,7.3,7.8,8.1,6.8c0.8-1-6-5.3-3.4-8.4c1.1-1.3,6.6,6.2,7,5.8c1.2-1.4-1.7-2.6-0.4-4.2c0.3-0.4,3.4,3.2,3.6,3"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.6,87.3c0.5-0.6,9.7,9.1,10.2,8.5c2.4-2.8-16.3-12.8-13.6-16c0.5-0.6,8.1,9.6,9.5,7.9 c5.5-6.5-15.1-11.6-12.1-15.2c0.6-0.7,6,7.3,7.1,6c1.3-1.5-4-4.9-2.1-7.2c0.1-0.1,4.2,4.2,4.5,3.8c0,0-0.8-3.1-0.4-3.6 c0,0,2.9,2.6,3,2.5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.3,68.3c0.3-0.4,3.9,4.3,4.4,3.7c0.4-0.4-4.2-5.5-2.5-7.6c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.9,116.3c0.7-0.9,5.2,4.9,5.5,4.6"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.2,98.7c0.8-0.9,9.1,14.9,12.7,10.6c3.6-4.3-12.2-8.4-9.1-12.1c0.1-0.2,3.1,2.8,3.2,2.7"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.9,111.4c6.1-7.3,6.5,14.2,10.8,9.1c1.1-1.3-10.3-5.5-6.9-9.6c0.9-1.1,5.9,5.5,6.2,5.2 c3.1-3.6-9.4-4.8-6-8.9c1-1.3,4.7,5,5.3,4.4"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.6,120.1c0.7-0.8,9.9,12.2,11.8,9.9c8.1-9.7-23.9-15.9-19.5-21.2c0.8-0.9,7,8.8,8.4,7.1 c3.1-3.7,11.8,14.1,16.5,8.4c0.1-0.2,6.6,7.5,7.5,6.3c0,0-1.3-3.4-0.8-4c0.1-0.1,4.2,4.7,4.8,4"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.4,134c0.6-0.6,5.3,4.6,5.3,4.5c0.1-0.1-5.2-6.5-4-7.9c6.1-7.2-0.4,4.4,2,1.7c0.1-0.1,2.9,0.7,3.5-0.1 c1.8-2.1,7.8,12.5,10.7,9c1.5-1.7-6.2-6.9-4.3-9.1c1-1.2,10,8.9,10.2,8.6c1.7-2-7.2-9-6-10.4c1.8-2.2,7.7,7.3,8.1,6.8 c1-1.2-6.8-8.4-5.9-9.4c0-0.1,6,8,7.4,6.2c1.9-2.3-4.7-5.5-2.9-7.7c0.6-0.6,4.5,5.6,5.4,4.5c0.3-0.3-2-4.5-0.6-6.1 c0-0.1,3.2,3.2,3.4,2.9"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70,121.7c1.1-1.3,5.5,5.6,6,5c0.2-0.2,0.5-2.8,1.1-3.5c0.4-0.5,5.2,4.9,5.5,4.6c0.1-0.2-3.3-2.9-1.8-4.7 c0.8-1,4.8,4.3,4.9,4.1c0.1-0.2-1.2-6.7-1.1-6.8s3.5,3.8,3.9,3.3c1.6-2-3.8-4.8-2.4-6.5c0.4-0.4,3.6,3.4,3.8,3.2"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.8,116.3c1.3-1.6,5.3,5.8,6,5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.9,119.9c0,0,3.8,3.7,4,3.4c0,0-3.6-4.9-2.9-5.7c0.3-0.4-0.4,2.4,0.9,0.8"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M72.4,120.8c0.6-0.7,3.1,2.8,3.2,2.7c0.8-1-5-7.3-4.4-8.1c0.1,0,4.8,5.9,5.7,4.7c1.2-1.4-0.9-3.7,0.2-5.1 c0-0.1,2.9,2.6,3,2.5c0.7-1.3,1.4-2.5,2.3-3.6c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.1,150.4c0.2-0.2,3.7,3.8,4.1,3.4c1.3-1.6-4.5-5.1-2.5-7.5c0,0,3.6,3.4,3.8,3.2c0,0-2.5-4.2-1.9-4.8 c0.1,0,3.2,3,3.4,2.8"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.3,153.8c0,0,4.1,4.8,4.8,4c2.2-2.6-5.7-5.9-3.7-8.3c0.3-0.3,3.6,3.7,4,3.3c0.4-0.4-4-5.5-2.3-7.5 c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.8,154.2c0.2-0.2,3.8,3.9,4.1,3.5c1.5-1.7-5.6-5.5-3.3-8.2c0,0,3.5,3.4,3.8,3.2c0,0-4-5.1-3.3-6 c0.1-0.1,3.8,4,4.2,3.5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.1,156.1c0,0,3.1,3,3.3,2.8c1.9-2.2-4.4-5.2-2.7-7.2c0.3-0.3,3.8,3.9,4.1,3.5c0.4-0.4-4.3-5.6-2.6-7.7 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,154.8c0,0,3.5,3.7,3.9,3.3c2-2.4-5-5.6-3.1-7.8c0.3-0.3,3.7,3.8,4,3.4c0.4-0.4-4.2-5.5-2.4-7.6 c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,157c0,0,2.9,2.6,3,2.5c1.8-2.2-4.5-5.3-2.7-7.3c0.3-0.3,3.7,3.8,4,3.4s-4.5-5.7-2.7-7.8 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77,144.9c0.2-0.3,3.7,3.5,3.9,3.3c0.2-0.3-1.4-4.2-0.2-5.7c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.9,155.7c0,0,3.1,2.9,3.3,2.7c1.6-1.9-4.3-4.2-2.8-6c0.1-0.2,3.2,3.1,3.4,2.9c0.4-0.4-4.5-5.7-2.7-7.8 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.1,119.6c0.1-0.2,3.3,3.2,3.5,2.9c0.5-0.6-9.1-6.9-6.5-10c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.7,147.2c0.1-0.2,3.2,3.1,3.4,2.9c0.2-0.2,2.1-1.9,3.1-3c0,0,2.9,2.7,3,2.5"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,144.8c0.3-0.3,3.3,3,3.4,2.8"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,148c0.3-0.3-0.5,2.2,0.8,0.7"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,149.8c0,0,3.1,3,3.3,2.8c2.5-3-7.5-6.6-5.1-9.4c0.7-0.9,5.1,6.6,6.3,5.3c0.4-0.4-4.4-5.6-2.6-7.8 c0.1-0.1,3.1,3,3.3,2.8"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,156.7c0,0,3.4,3.5,3.7,3.1c1.9-2.2-5.3-5.1-3.5-7.2c0.3-0.3,3.7,3.9,4.1,3.4c0.4-0.5-5.2-6-3.2-8.3 c0.1-0.1,3.1,3,3.3,2.8"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,155.8c0.4-0.4,3.9,4.4,4.4,3.7c0.4-0.5-5.1-6-3.1-8.2c0-0.1,3,2.8,3.1,2.6"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,156.1c0.1-0.2,3.1,3.4,3.5,2.9c0.4-0.4-6.5-4.9-4.7-7.1c0-0.1,3.2,3.2,3.4,2.9"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.5,151.3c0.1-0.1,3,2.8,3.1,2.6c0.3-0.3-3.5-4.5-2.1-6.2c0.1-0.1,3.1,3,3.3,2.8"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.1,165.2c0.1-0.2,3.5,3.7,3.9,3.3"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,156.7c0.2-0.2,3.9,4.4,4.4,3.7"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,164.3c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.9,156.9c0,0,3,2.7,3.1,2.6"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.6,158.8c0.1-0.1,3.3,3.4,3.6,3"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,161.5c0.2-0.1,3.6,3.9,4,3.4"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,159.7c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.1,157.8c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,156.1c0.1-0.1,3.1,3,3.3,2.8"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.9,164.4c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.5,158.4c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.9,155.1c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,162c0.1-0.1,3.3,3.4,3.6,3.1"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,147.6c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55,157.1c0.1-0.1,3.2,3,3.4,2.8"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.5,162.4c0-0.1,3,2.7,3.1,2.6"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.5,146c0.2-0.2,3.2,3.3,3.5,2.9s-2.9-5-1.4-6.8c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.8,143.1c0.2-0.2,3.3,3.3,3.6,3c0.3-0.3-2.4-4.7-1-6.4c0.1-0.1,3.3,3.3,3.5,3"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,139.9c0.2-0.1,3.2,3.1,3.4,2.8c0.2-0.3-2.6-3.7-1.5-5c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.4,117.7c0,0,2.9,2.5,2.9,2.5"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,181.8c0.6-0.7-10.3-8.1-7.2-11.6c0.1-0.1,3.1,3,3.3,2.8"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,178.7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,153.5c0.1-0.1,3.1,3,3.3,2.7"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,4.9c0.1-0.1,2.9,2.8,3.1,2.6s2.9-0.4,3.8-1.4c0.1-0.1,3.6,3.9,4,3.4"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.5,8.9c0.2-0.2,3.3,3.2,3.5,2.9c0.2-0.2,2.1-1.9,3-3.1c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.5,3.2C64.7,3,68,6.8,68.3,6.4c0.5-1,1-2,1.7-2.9c0.1-0.1,3.3,3.4,3.6,3"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.1,7.1c0.1-0.1,3.1,2.8,3.2,2.7c0.7-1.2,1.5-2.5,2.3-3.6c0,0,3,2.7,3.1,2.6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.1,8.8c0.1-0.1,3,2.9,3.2,2.7c0.2-0.2,0.5-3.1,1.5-4.3c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.8,2.2c0.1-0.1,3.1,3,3.3,2.8"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,4.6C60,4.5,62.8,7.4,63,7.1c0.2-0.2,0.1-3.4,1.1-4.6c0.1-0.1,3,2.8,3.2,2.7"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.7,6.1c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.7,3.5c0-0.1,3,2.8,3.2,2.6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.3,8.9c0-0.1,3,2.7,3.1,2.6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,5.4c0,0,3,2.7,3.1,2.6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71,1.9c0.1-0.1,3.1,3,3.3,2.8"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.4,4.8c0,0,2.9,2.6,2.9,2.5"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.2,19.2c0.3-0.3,3.6,3.9,4,3.4c0.4-0.5-7.1-5.6-5-8.1c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.3,19.9c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109,15.5c0.1-0.2,3.6,3.8,4,3.3"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,24.4c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,6.2c0.1-0.1,3.1,2.9,3.3,2.7c0.1-0.2,0.2-2.2,0.9-3c0,0,2.9,2.6,2.9,2.5"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.1,5c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4,5.4c0.1-0.1,3.2,3.1,3.4,2.9"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,5.7c0-0.1,3,2.9,3.2,2.7"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,7.4c0,0,3.2,2.9,3.3,2.8"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,9.3c0.2-0.2,3.3,3.3,3.6,3c0.7-1.3,1.4-2.5,2.3-3.6c0.6-0.7,6.1,8.5,7.8,6.5"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.7,9.5c0,0,3,2.7,3.1,2.6"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.6,2.5c0,0,2.9,2.7,3,2.6"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,7.7c0-0.1,4.1,4.2,4.5,3.8c0,0-0.7-3-0.3-3.5c0.1-0.1,4.5,5.1,5.1,4.3"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.1,6.7c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M79,70.3c0.4-0.4,3.7,3.7,3.9,3.3c1.7-2-5.7-4-3.6-6.6c0.1-0.1,3.3,2.8,3.3,2.7"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.6,81.4c0.2-0.2,0.5,1.9,1.2,1c1.5-1.8-6.7-5.5-4.5-8.1c0.2-0.2,4.6,6,5.7,4.7c2.3-2.7-5.6-6.3-4.9-7.1 c0.2-0.2,3.3,3.1,3.5,2.9"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M93.9,71.8c0.3-0.4,3.9,3.4,4,3.3c1.2-1.5,1.7-2.3,2.5-3.3c0.8-1,4.5,4.8,5,4.2"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.3,91.2c1.2-1.5,5.1,6.7,6.3,5.3c1.7-2-2.9-5.2-2.2-6.1c2.5-2.9,8.4,14,11.8,9.9c0.3-0.4-10.6-6.8-7.2-10.9 c4.2-5-1.8,2.7,0.3,0.2c0.5-0.9,0.9-1.8,1.2-2.7c2.3-2.8,8.4,7.1,8.4,7.1c0.5-0.6-5.9-9.3-5.2-10.2c1.4-1.7,5.2,6.7,6.4,5.4 c2.6-3-8.6-5.1-5.5-8.8c0.5-0.6,6.7,6,6.9,5.8c0.2-0.2-5.3-6.6-4.8-7.2c0.5-0.6,4.8,5.1,5.3,4.5c2.3-2.8-4.6-5.2-3.3-6.7 c0,0,4.5,4.3,4.8,4c0.3-0.3-8.4-5.4-5.3-9.1c0,0,3.8,4.1,4.3,3.6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M78.9,79.5c1.7-2,9,13.2,11.8,9.9c1.2-1.5-12.9-11.8-11.3-13.6c0.4-0.5,6.2,8.9,8,6.7"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M72.8,86.4c0.2-0.2,6.1,6.2,6.6,5.5c1-1.3-0.9-2.9-0.1-3.9c0.5-0.6,3.7,4,4.1,3.5s-0.5-3.2-0.2-3.7 c0.7-0.9,1.9,1.6,1.9,1.6c1.2-1.4-8.5-6.2-6.4-8.8c1.2-1.4,7.8,13.2,11.1,9.3"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73,84.5c1-1.2,4.9,5.4,5.5,4.6s-5.8-8.9-5.7-9.1c0.4-0.4,4.1,4.8,4.7,4s-6.6-4.4-4-7.5 c0.4-0.4,4.3,4.4,4.7,3.9c0,0-6-5.1-4.2-7.3c0.7-0.8,4.6,6.4,5.9,4.9c0.9-1.1-7.4-7.5-5.9-9.3c0.4-0.5,3.9,4.9,4.7,3.9 c1.8-2.2-5.7-6.8-5-7.5c0.2-0.3,4.5,4.3,4.8,4c1.1-1.3-3.5-4.3-1.4-6.9c0.2-0.2,3.6,3,3.6,3"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M79.8,66.2c0.1-0.1,3,2.6,3,2.5c2.9-3.5-9.2-9.5-8.4-10.5c0.6-0.7,8.2,7.6,8.5,7.2c2.5-3-5.6-7.1-5.3-7.5 c1.2-1.5,5.4,6.8,6.6,5.5c1.1-1.3-1.2-5-0.6-5.7c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M56.7,52.7c1.2-1.4,5.7,5.8,6.2,5.2"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M60,56.9c0.1-0.1,3,2.5,3,2.5c1.1-1.3-9.2-6.4-5.8-10.5c2.5-2.9,11.3,10.9,12,10.1c1-1.2,2.2,0.2,3.3-1.1 c1.7-2,6.1,7,7,5.9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.8,47.6c0.8-1,4.7,4.5,5,4.2c0.8-1-6.5-5.2-4.5-7.6c0.4-0.4,5.8,5.4,6.1,5.1c2.2-2.6-6.8-7.9-6.3-8.5 c0.5-0.6,5.2,5.4,5.7,4.8c0.5-0.6-7-6.4-4.4-9.4c0.7-0.9,4.8,5.2,5.4,4.5c1.7-2.1-5-6.2-4.5-6.8c0.5-0.6,5.2,5.9,5.9,5 c2.5-3-5.3-6.6-4.6-7.4c1.4-1.7,5.7,8.4,7.5,6.3c1.2-1.4-6.3-5.5-4.4-7.7c0.3-0.4,8,7.5,8.4,7c1-1.1-4.9-6.4-3.8-7.7 C70.6,29,76.2,36,77,35c1.8-2.1-2.3-5-1.3-6.2c0.2-0.1,3.6,3.6,3.9,3.3c0.8-0.9,0-3.1,1.1-4.5c0,0,3.4,3.2,3.6,3 c1-0.2,1.9-0.5,2.8-0.9c0.3-0.4,0.6,3.9,2.3,1.9"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M91.9,55.3c0.1-0.1,3.1,3,3.3,2.8c0.9-1.1-1.8-4.7-0.7-6c0.6-0.7,7.2,6.3,7.3,6.1c1.9-2.2-8.6-9.8-7.1-11.4 c2.2-2.7,9.3,8.8,9.8,8.2c1.5-1.8-11.4-11.5-10.2-13c0.1-0.1-2.7,4,0.4,0.4c2.1-2.4-5.2-5.7-3.3-8c1.6-2,8,11.9,10.6,8.9 c0.8-0.9-14.6-9.8-10.6-14.5c0.3-0.3,4.2,5,4.9,4.1"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.3,101.1c0,0,3,2.7,3.1,2.6c-0.1-1,0-2,0.2-3.1c0,0,3.2,3.1,3.4,2.8"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.2,102.8c0.1-0.1,3.6,3.1,3.6,3.1c0.6-0.8-1.6-4-1.1-4.5c0.6-0.8,3.3,3.1,3.4,2.9c0.3-0.4,0.8-3.2,1.1-3.6 c0,0,3.7,4,4.1,3.5c1-1.1,1.3-2.3,2.2-3.4c0.2-0.2,3.4,3.6,3.8,3.2c0.2-0.3,1.7-2.3,2.6-3.4c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M75.1,97.7c0.3-0.4,3.7,4,4.2,3.5c0.2-0.2,0.2-3.3,1.2-4.5c0.2-0.2,4,4.5,4.5,3.8"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.5,57.5c0.1-0.1,3.6,3.6,3.9,3.3"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.7,63.2c0,0,3.2,3,3.3,2.8c3.4-4.1-11.3-8.2-8.1-12c0.4-0.5,4.2,4.9,4.9,4.1c0.5-0.6-7.4-6.9-5-9.8 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.4,63c0-0.1,3.4,3.3,3.6,3"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.7,69.5c0,0,3.5,3.7,3.9,3.2c1.9-2.3-4.6-5.4-2.8-7.6c0.2-0.3,3.6,3.7,3.9,3.3c0.3-0.4-3.1-5-1.5-6.9 c0,0,3,2.7,3.1,2.6"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.3,61c0.1-0.1,4.6,4.8,5,4.2c0,0-0.9-3.2-0.5-3.7c0.1-0.1,3.6,3.6,3.9,3.3"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.5,65.6c0.1-0.1,3.1,2.9,3.2,2.7c0.4-0.5-6.4-6.4-4.2-8.9c0.1-0.1,3.1,3,3.3,2.8"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.8,70.2c0,0,3.4,3.4,3.7,3.1c0.9-1.1,1.5-2.2,2.4-3.2c0.2-0.3,3.5,3.6,3.8,3.2c0.2-0.2,0.1-3.4,1.1-4.6 c0.2-0.2,3.8,4.3,4.4,3.7"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100,64.2c0.7-0.9,5.1,6.6,6.3,5.3c0.2-0.2-0.8-3.2,0.2-4.3c0,0,2.9,2.7,3,2.5"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107,88.8c0,0,3.2,3.2,3.5,2.9c1.8-2.2-4.3-5.3-2.6-7.4c0.2-0.3,3.4,3.4,3.7,3.1s-3.5-5.2-1.9-7.1 c0,0,2.9,2.6,3,2.5"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.4,93.5c0,0,3.4,3.4,3.6,3.1c1.2-1.5-1-3.8,0.1-5.1c0.2-0.2,3.3,3.3,3.6,3c0.2-0.3-1.1-4.1,0.1-5.5 c0-0.1,3,2.8,3.2,2.6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.1,79.5c1,0.9,2,1.7,3,2.5c1.7-2-4-4.9-2.4-6.8c0.2-0.2,3.3,3.3,3.6,3c0.4-0.5-6-6.3-3.9-8.9 c0-0.1,3,2.8,3.1,2.6"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.3,66.7c0.2-0.2,3.3,3.5,3.6,3.1c0.3-0.4-4.8-4.3-3.3-6.1c0,0,2.9,2.4,2.9,2.4"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.2,69.7c0.2-0.3,3.5,3.4,3.7,3.1s4.2,0.4,5.4-1c0.1-0.1,3.1,3,3.3,2.8"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74,94.4c0.2-0.3,3.4,3.5,3.7,3.1c0.4-1.1,0.8-2.3,1.5-3.3c0.1-0.1,3.3,3.3,3.6,3"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78.7,99.3c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.2,95.1c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.5,100.7c0-0.1,3,2.8,3.1,2.6"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.6,100.6c0,0,2.8,2.6,2.9,2.4c0.1-0.2-0.7-2.3,0-3.1c0-0.1,3,2.8,3.2,2.6"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.5,68.4c0-0.1,3,2.8,3.1,2.6"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73.6,122.4c0.1-0.1,3.2,2.6,3.2,2.6c1-1.2-2.5-6-1.8-6.9c1.6-2,7.1,6.6,7.4,6.2c0.9-1.1-6.2-8-5.4-9 c0,0,6.4,8.8,8.1,6.8c1.8-2.2-4.2-5.3-2.5-7.3c0.5-0.6,4.4,5.3,5.2,4.4c0.3-0.4-2.6-4.8-1.1-6.6c0-0.1,3,2.8,3.2,2.7"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.5,113.6c0.2-0.2,3.4,3,3.5,2.9c1.8-2.2-4.7-3.5-2.6-6c0.9-1.1,4.5,4.8,5,4.2"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.2,108.3c0.1-0.1,3.6,3.6,3.9,3.2"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.5,117.1c0.5-0.6,2.8,2.6,2.9,2.4c1.1-1.3-7.4-8.8-6.5-9.8c0-0.1,6.2,8.4,7.8,6.5c2.8-3.3-8.6-7.1-6-10.2 c0.8-1,5.4,7.1,6.6,5.6c0.4-0.5-6.8-6.6-4.5-9.3c0.1-0.1,3.1,3,3.3,2.8"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.3,102.1c0.1,0,2.9,2.8,3.1,2.6c0.1-0.2-0.4-2.4,0.3-3.2c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.4,100.6c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M111.4,78.1c0.3-0.3,3.8,3.9,4.1,3.5c0.4-0.4-4.7-5.7-2.8-7.9c0,0,3,2.7,3.1,2.6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.4,83.4c0.1-0.1,3.1,2.9,3.3,2.7c0.3-0.4-3.1-5-1.6-6.9c0.2-0.2,3.6,3.9,4.1,3.4"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.9,67.3c0.1-0.1,2.9,2.9,3.1,2.6c0.2-0.3-1.6-4-0.4-5.4c0.1-0.1,3.1,3,3.3,2.8"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.4,71.3c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.7,79.8c0,0,2.8,2.4,2.8,2.4c0.3-0.4-3.5-4.4-2.1-6c0,0,2.9,2.7,3.1,2.6"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.3,61.4c0,0,2.9,2.7,3.1,2.6"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.1,62.8c0,0,2.9,2.7,3,2.5"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.9,66.6c0.7-0.8,4.1,4.5,4.6,3.9c0.5-0.7-1-3.6-0.6-4.1s0.8,0.7,0.8,0.7c0.4-0.5-1.4-3-0.6-3.9 c0.2-0.2,3.5,4,4,3.4"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.9,68.6c0.2-0.2,3.9,3.6,4.1,3.4c0.7-0.8-2.5-2.6-1.2-4.1c0.3-0.4,4.3,3.7,4.3,3.6"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.9,65.6c0.1-0.2,3.3,2.8,3.3,2.8"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.2,69.3c0.8-0.9,4.5,4.3,4.8,4c0.1-0.1,3.4-2.8,3.5-2.9c0.1-0.1,3.5,3.8,3.9,3.3c1.3-1.6-2.2-4-1-5.4 c0.4-0.4,3.6,3.4,3.8,3.2"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.1,66.7c0.4-0.5,4.3,3.9,4.4,3.7c1.3-1.6-2.4-2.8-0.9-4.7c0.1-0.2,3,2.7,3.1,2.6"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.8,77c0.1-0.1,2.9,2.6,3,2.5c0.8-1-4-4.1-2.7-5.7c0,0,3.1,2.6,3.1,2.6c0.9-1-4-6-3.1-7.1 c0-0.1,3.3,3,3.4,2.9c2.1-2.5-3.5-5.7-2.4-7c0.1-0.1,3.1,2.9,3.2,2.7c1.1-1.3-3.1-4.5-1.3-6.6c0,0,3.1,2.6,3.1,2.6 c0,0-3.1-4.5-2.4-5.3c0.1-0.1,3.9,4.2,4.4,3.7"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.8,64.6c0.2-0.2,4.2,3.5,4.2,3.5c1-1.2-4-5.5-3.2-6.4c0.5-0.5,2.5,2.3,2.6,2.2c0.8-0.9-4.7-7-4-7.8 c0,0,4.3,5.1,5,4.2c2-2.4-4.9-5.5-3.1-7.8c0.3-0.4,3.8,4.2,4.3,3.6c0.3-0.4-3.3-5.1-1.7-7c0.1-0.1,3,2.8,3.2,2.7"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.1,80.7c0.6-0.7,4.6,5.7,5.5,4.6c0.6-0.7-9.4-7.7-6.6-11.1c0.1-0.1,3.3,3.2,3.5,2.9"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,80.3c0.4-0.4,4,4.1,4.4,3.6s-5.7-6.2-3.7-8.6c0,0,2.9,2.7,3,2.6"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.8,78.4c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.1,63c0.2-0.2,3.7,3.9,4.1,3.4"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.8,88.2c0.1-0.2,3.6,3.8,4,3.3"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.1,27.2c0.2-0.2,3.3,2.9,3.4,2.8s-1.5-3-0.9-3.8c0.2-0.2,3.3,3.4,3.6,3.1c0.6-0.7,1.1-2.9,1.9-3.9 c0.1-0.1,3.5,2.9,3.5,2.9c0.6-0.7,1.4-3.4,1.8-3.9s2.3,2.1,2.4,2c0.3-0.4,2.3-2,2.5-2.3c0,0,3.2,3.2,3.5,2.9 c0.9-1.1,1.5-2.2,2.4-3.2c0.4-0.4,4,4.3,4.5,3.8s7.4,5,9.6,2.4c0.4-0.5,4.9,6.4,6,5.1"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.3,24c0.2-0.3,3.9,3.3,3.9,3.3"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.1,26.7c0.1-0.1,3.8,3.3,3.8,3.2c2.1-2.5-4.3-6.2-4-6.5c0.7-0.9,4.4,4.9,5,4.2c1.2-1.4-1.6-5.3-1-6 c0.1-0.1,3.2,2.7,3.2,2.7"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.8,21.1c0.4-0.4,3.7,3.4,3.8,3.2"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.4,18.2c0.2-0.3,3.3,3.1,3.4,2.9"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.1,18.1c0.1-0.1,4.5,4.7,5,4.2c0,0-2.9-4.4-2.3-5.1c0,0,3.3,3.2,3.5,3"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.2,20.8c0,0,3.5,3.7,3.9,3.3c1.2-1.4-0.9-3.7,0.2-5c0.2-0.2,3.4,3.4,3.6,3.1c0.2-0.3-1.2-4.1,0-5.6 c0,0,2.9,2.7,3.1,2.6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.6,60.5c0,0,3.5,3.3,3.6,3.1c0,0-1.3-3.5-0.9-4c1,1,2.1,1.9,3.2,2.7"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.9,57.5c0.2-0.2,3.5,3.1,3.6,3c0.1-0.1-3.2-6-2.2-7.2c0.3-0.4,3.5,3.1,3.6,2.9c0.1-0.2-4-4.2-2.8-5.5 c0.3-0.3,3.5,4,4,3.4c1.2-1.4-4.3-6-2.8-7.8c0.1-0.1,3.1,2.6,3.1,2.6c0.7-0.9-0.6-4.7,0-5.4c0-0.1,1.1,1,1.1,1 c0.4-0.5-0.8-4.4-0.5-4.8c1,0.9,2,1.8,3.1,2.6c1.5-1.8-2.7-4.6-1.3-6.3c0.2-0.2,3.2,3.2,3.5,2.9c0.3-0.3-2.2-4.6-0.8-6.3 c0,0,2.9,2.7,3,2.6"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,20.9c0,0,3,2.6,3,2.5"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79,24.3c0.3-0.3,1.8,1.6,1.8,1.5c0.4-0.4,0.2-3.7,0.5-4c0.1,0,4,4.6,4.6,3.9c1.1-1.2,3-0.7,4-1.9 c0.2-0.2,3.2,3.1,3.4,2.8c0.2-0.3-1.2-4.1,0-5.5c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.3,12.6c0.2-0.2,4.9,5.8,5.8,4.8"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.2,16.6c0.4-0.4,4,4.4,4.5,3.8c0.5-0.6-9.5-6.1-7-9.1c0.3-0.3,4.3,5.2,5.1,4.3"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107,35.2c0,0,2.9,2.4,2.9,2.4"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.7,45.3c0,0,3.6,3.9,4,3.4c2.8-3.2-8.2-7-5.7-10c0.4-0.5,4,4.6,4.6,3.9c0.3-0.4-3.8-5.4-2.1-7.4 c0,0,2.9,2.7,3.1,2.6"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.9,21.6c0.4-0.5,4.2,3.8,4.3,3.6c2.5-2.9-7.8-3.9-5-7.2c0.3-0.4,3.3,3.1,3.5,2.9"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.9,17.2c0.1-0.1,3.5,3.5,3.8,3.2"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.5,23.5c0.1-0.1,3,2.7,3.1,2.6c0.4-0.5-7.4-5.7-5.2-8.3c0.1-0.1,3.3,3.3,3.6,3"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.7,24c1-1.2,6.2,5.8,6.5,5.5c1.3-1.5-2.3-2.8-0.8-4.5c0.2-0.4,3.3,3.1,3.4,2.9"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.4,23c0,0,3.7,3.5,3.9,3.3c0,0-1.5-3.6-1.1-4.1c0,0,3.2,3.1,3.4,2.9"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.2,21.2c0,0,2.9,2.6,3,2.5"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.6,50.8c0,0,3.1,3,3.3,2.8c2.5-2.9-7-6.5-4.8-9.2c0.4-0.5,4,4.6,4.7,3.9c0.4-0.5-5.4-6.1-3.4-8.4 c0.1-0.1,3.1,3,3.3,2.8"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54,28.6c1,1,2.1,1.9,3.3,2.7"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.1,39.3c0.3,0.2,0.6,0.5,0.9,0.7c0.4-0.4-1.4-3.6-1.1-4c0,0,3.2,3.2,3.4,2.9c1.8-2.2-4.2-5.3-2.5-7.3 c0.4-0.4,4,4.4,4.5,3.8c0.4-0.4-3.5-5.2-1.9-7.2c0.1-0.1,3.3,3.3,3.5,3"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.6,22.6c0.2-0.3,1.7,1.5,1.7,1.4c0.4-0.5,0.4-3.5,0.7-3.9c0,0,3.2,3.2,3.5,2.9c1.4-1.7-2.1-4.3-0.8-5.9 c0.3-0.4,3.8,4.2,4.3,3.6c0.2-0.2-0.1-3.5,1-4.8c0,0,2.9,2.5,2.9,2.5"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.4,31.6c0.2-0.3,3.5,3.7,3.9,3.3c0.6-0.7-9.3-7.7-6.5-11c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.1,23.1c0,0,3.4,3.4,3.7,3.1c1.2-1.4-0.8-3.6,0.3-4.9c0.2-0.2,3.5,3.5,3.8,3.2c0.2-0.3-1.3-4.2-0.1-5.7 c0,0,2.9,2.6,3,2.5"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,45.1c0,0,3,2.6,3,2.6c1.1-1.3-4.5-3.8-2.8-5.8c0,0,2.9,2.5,3,2.5s-2.8-4.4-2.2-5.1c0,0,3.2,3,3.3,2.8"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.1,43.5c0,0,3.1,3,3.3,2.8c2.2-2.6-5.9-6-3.8-8.4c0.2-0.3,3.4,3.5,3.7,3.1s-2.9-4.9-1.4-6.7 c0.1-0.1,3,2.8,3.2,2.7"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.9,60.9c0-0.1,3.1,2.6,3.1,2.6c0.8-1-1.4-5.3-0.7-6c0.1-0.1,1,0.9,1,0.9c0.4-0.5-0.9-4.5-0.5-4.9 c0,0,3.2,3.1,3.4,2.9c1.4-1.8-2.5-4.5-1.1-6.1c0.1-0.1,3,3.1,3.3,2.7c0.3-0.3-2-4.5-0.6-6.1c0,0,2.9,2.4,2.9,2.4"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.6,24.4c0.1-0.1,3,2.8,3.2,2.6c0.3-0.4-4-5.4-2.3-7.5c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105,36c1,0.9,2,1.8,3.1,2.6c1.3-1.6-3-3.8-1.8-5.3c0.3-0.3,3.6,3.7,3.9,3.3c0.3-0.4-3.6-5.3-1.9-7.2 c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.1,14c0.2-0.3,3.5,3.4,3.7,3.1c0.2-0.2,0.7-3.1,1.7-4.2c0.1-0.1,3.4,3.6,3.8,3.2"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.7,46.4c0,0,3.7,3.6,3.9,3.3c0,0-3.6-4.8-2.9-5.7c0.1-0.1,3.7,3.8,4.1,3.4"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.1,44c0.1-0.1,3.1,3,3.3,2.8"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.2,41.1c0,0,2.9,2.6,3,2.5c1.6-1.9-4.2-4.4-2.7-6.2c0.2-0.3,3.3,3.6,3.7,3.1c0.4-0.5-5.1-5.9-3.1-8.2 c0,0,3,2.8,3.1,2.6"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.5,36.7c0.1-0.1,3,2.7,3.1,2.6c0.3-0.5-5-5.9-3.1-8.1c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.5,17.7c0.2-0.3,3.5,3.5,3.8,3.2c0.3-0.4-4.6-4.1-3.1-5.8c0.2-0.3,4,4.6,4.6,3.9"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.2,23.2c0.1-0.1,3.1,3,3.3,2.8c0.4-0.4-6.4-5-4.5-7.2c0.1-0.2,3.5,3.7,3.8,3.2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.9,33.1c0.1-0.1,3,2.8,3.1,2.6c0.5-0.6-8.5-6.8-6-9.8c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.7,31.1c0.3-0.3,3.7,3.7,4,3.4c0.3-0.3-2.2-4.6-0.8-6.3c0,0,3,2.7,3.1,2.6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.3,43.9c0,0,2.9,2.4,2.9,2.4c0.9-1.1-3.5-3.5-2.1-5.2c0,0,3.6,3.4,3.8,3.2c0,0-2.2-4-1.7-4.6 c0,0,2.9,2.5,2.9,2.5"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.1,40c0.1-0.1,2.9,2.9,3.1,2.6c0.2-0.3-3.3-3.6-2.1-5c0,0,2.9,2.6,3,2.5"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,32.1c0.1-0.1,2.9,3,3.2,2.7s-1.8-4.4-0.5-6c0-0.1,3,2.8,3.2,2.6"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.8,36.9c0.1-0.1,3.1,3,3.3,2.8c0.5-0.6-7.5-6.9-5.1-9.8c0-0.1,3,2.8,3.2,2.7"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.3,10.8c0.1-0.1,3,2.9,3.2,2.7c0.2-0.2,2.4-0.9,3.3-1.9c0-0.1,3.2,3.2,3.4,2.9"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.4,22.6c0.1-0.1,3,2.9,3.2,2.7c0.2-0.2-0.4-3.5,0.6-4.7c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.2,62.5c0.1-0.1,2.9,2.7,3,2.5c0.4-0.5-7.8-5.6-5.7-8.2c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,26.4c0,0,2.9,2.5,2.9,2.4c0.2-0.2-0.5-3.3,0.5-4.4c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.2,13.6c0.1-0.2,3.2,3.1,3.4,2.9c0.9-0.6,1.7-1.3,2.5-2.1c0,0,2.9,2.6,3,2.5"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.1,25.1c0.1-0.1,2.9,2.9,3.1,2.6c0.2-0.3-3.3-3.4-2.1-4.8c0.1-0.2,3.4,3.6,3.8,3.2"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,39.2c0.1-0.1,3,2.7,3.1,2.6c0.3-0.4-2.8-4.9-1.3-6.6c0-0.1,3,2.7,3.1,2.6"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,25.1c0.1-0.1,2.9,2.8,3.1,2.6c0.2-0.2-1.2-3-0.3-4.1c0,0,3,2.7,3.1,2.6"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.4,35.8c0.1-0.1,3.1,3,3.3,2.8c0.4-0.5-7-5.1-5-7.5c0.1-0.1,3.1,3,3.3,2.8"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90,25.1c0.1-0.1,2.9,2.7,3,2.5s-1.5-2.8-0.6-3.8c0,0,2.9,2.6,3,2.5"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,34.7c0.1-0.1,3,3.2,3.3,2.8c0.3-0.4-3.4-4.9-1.9-6.7c0.1-0.1,3.3,3.3,3.5,3"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.2,61c0.1-0.1,3,2.8,3.1,2.6c0.3-0.3-4.1-3.9-2.7-5.5c0,0,3,2.7,3.1,2.6"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.3,40.4c0-0.1,2.9,2.6,3,2.5c0.3-0.4-2.6-4.8-1.1-6.5c0,0,2.9,2.6,2.9,2.5"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.7,50.2c0.3-0.2,4,4.4,4.5,3.8"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,25.2c0.2-0.2,3.7,4,4.2,3.5"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.6,10.2c0.1-0.1,3,2.8,3.2,2.6"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.8,44.5c0-0.1,2.9,2.6,3,2.5c0.3-0.4-4.7-5.1-3-7.1c0,0,2.9,2.4,2.9,2.4"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.8,48c0.1-0.1,3,2.8,3.2,2.7c0.3-0.4-4.7-4.6-3.2-6.5c0,0,3,2.7,3.1,2.6"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,13.4c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.5,16.1c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,10c0-0.1,3.2,3.2,3.4,2.9"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.5,24.4c0,0,2.8,2.4,2.8,2.4c0.2-0.2-1.6-3.2-0.6-4.4c0,0,2.9,2.4,2.9,2.4"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.9,39c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.2,38.7c0-0.1,2.9,2.6,3,2.5c0.3-0.4-3-4.8-1.5-6.6c0,0,2.9,2.6,3,2.5"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.9,12.5c0.1-0.2,3.5,3.7,3.8,3.2"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.5,42.9c0-0.1,2.9,2.6,3,2.5c0.2-0.4-2.7-4-1.4-5.4c0,0,2.9,2.6,3,2.5"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57,33.5c0,0,2.9,2.7,3.1,2.6"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.5,10.5c0.1-0.1,3.1,3,3.3,2.8"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,40c0.1-0.1,3,2.8,3.2,2.7"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.8,22.3c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.8,22.6c0.1-0.1,3.3,3.3,3.5,3"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,38.7c0-0.1,3,2.8,3.1,2.6"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,67.4c0,0,2.9,2.6,3,2.5"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,24.3c0,0,2.9,2.5,2.9,2.4"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.4,19c0,0,2.9,2.6,3,2.5"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.6,36.5c0.1-0.1,3.1,3,3.3,2.8"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.9,17.7c0-0.1,3,2.7,3.1,2.6"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.5,14.7c0.1-0.1,3.1,3,3.3,2.8"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,73c0,0,2.9,2.6,2.9,2.5"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,15.7c0,0,2.9,2.6,3,2.5"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.9,2.9c0-0.1,3,2.8,3.1,2.6"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,32.6c0,0,2.9,2.7,3,2.6"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,40.4c0,0,2.9,2.6,3,2.5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.7,38.3c0,0,2.9,2.4,2.9,2.4"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.3,51.1c0,0,2.9,2.7,3,2.6"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.3,17.8c0,0,3,2.7,3.1,2.6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.7,32.9c0,0,2.9,2.7,3,2.6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,26.5c0,0,2.9,2.7,3.1,2.6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.2,21.6c0,0,2.9,2.6,2.9,2.5"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,20c0,0,2.9,2.4,2.9,2.4"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,30.8c0,0,2.8,2.5,2.9,2.4"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,43.3c0,0,2.9,2.4,2.9,2.4"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.8,17.8c0,0,2.9,2.5,2.9,2.4"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.2,41c0,0,2.9,2.4,2.9,2.4"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.3,32.9c0,0,2.9,2.6,2.9,2.5"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,37.6c0,0,2.9,2.4,2.9,2.4"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.3,34.8c0,0,2.9,2.5,2.9,2.4"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.6,148.1c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.6,84.1c1,0.9,2.1,1.8,3.2,2.7"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.2,87.2c0.1-0.1,3,2.8,3.1,2.6c0.9-1.1,4.1,1.8,5.9-0.3c0.1-0.1,3.6,3.4,3.8,3.2c0.2-0.2,0.1-2.7,0.6-3.3 c0.1-0.1,3.1,3.1,3.3,2.8c0.3-0.3-0.3-3.6,0.1-4c0.1-0.1,3.3,3.3,3.5,3"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.9,75.9c0.7-0.9,7.5,9.5,9.1,7.6c3.7-4.4-8.9-7.2-5.9-10.8c0.1-0.1,4.8,4.7,5.1,4.3c1.3-1.6-0.7-3.5,0.3-4.7 c0.9-1,4.4,5.4,5.2,4.4c0.4-0.4,1-2.1,1.2-2.5c0.7-0.8,1.6,1.3,1.6,1.3c0.3-0.4,0-2.2,0.6-2.9c0.1-0.1,3,2.9,3.2,2.7"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.7,84.2c0.3-0.3,4.5,4.3,4.7,4c1.1-1.3-4.8-4-2.6-6.6c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.1,85.5c3.1-3.7,10.1,13.6,12.6,10.6c1.8-2.3-6-6.8-5.1-7.9c0.1-0.1,3.2,2.7,3.2,2.7"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.2,76.9c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M54.1,93.7c0,0,6.4,9.2,8.2,6.9c3.6-4.3-14.5-6.5-9.8-12.2c4.3-5.2,1.6,10.2,6,5c0.7-0.9,4.7,1.4,6.2-0.4 c0.7-0.8,4.2,3.8,4.3,3.7c0.7-0.9-5.9-5.9-4.5-7.4c0.1-0.2,3,2.9,3.2,2.7c1.2-1.4-3.7-5.2-2-7.3c0.1-0.2,3.2,2.9,3.3,2.8 c0.6-0.8-3.7-4.5-1.6-7c1.1,0.9,2.2,1.8,3.3,2.7c2.1-2.6-5.8-3.9-3.4-6.8c1.1-1.4,5,5.5,5.7,4.8"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.9,71.4c0-0.1,3.5,3.5,3.8,3.2"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.9,82.5c0.5-0.6,6.4,5.6,6.5,5.5c1.9-2.2-8.5-9.9-7.2-11.5c1.3-1.6,5.8,5.4,6,5.1c0.7-0.8-3.7-6.4-3.1-7.1 c0,0,4.4,5.2,5.1,4.3c2-2.4-5.1-5.7-3.2-7.9c0.2-0.2,3.3,3.5,3.7,3.1s-5.1-6-3.2-8.2c0.1-0.1,3.3,3.3,3.5,3"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.8,110.6c0.2-0.2,4.5,4.8,5,4.2c3.2-3.8-8.4-7.2-6.7-9.3c1.2-1.4,9.3,12.2,11.4,9.6c0.9-1.1-1.5-3.8-0.1-5.5 c0.1-0.1,6.1,6.8,6.9,5.8c0,0-2.8-4.4-2.2-5.1c1,0.9,2.1,1.8,3.2,2.7"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.4,103.2c0.3-0.3,3.6,3.9,4.1,3.4c0.2-0.2-0.1-3.5,0.9-4.8c0.1-0.1,3,2.8,3.2,2.7"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.2,89.4c0.1-0.1,3.9,4.1,4.3,3.6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.2,89.6c1.7-2,7.3,6.7,7.6,6.4c0.3-0.4,1.3-2.8,1.6-3.1c0,0,4.3,5.1,5.1,4.3c1.4-1.7-2-4.3-0.7-5.8 c0.2-0.2,3.4,3.3,3.7,3.1s-0.8-3.9,0.3-5.3c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40,69.7c0.1-0.1,3,2.7,3.1,2.6c1.1-1.4-4.1-4.6-2.3-6.8c0,0,3.4,3.2,3.6,3c0,0-3.2-4.6-2.5-5.4 c0.1-0.1,3.7,3.8,4.1,3.4"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43,69.8c0,0,4,4.5,4.5,3.8c2.2-2.6-5.8-6-3.7-8.4c0.2-0.2,3.2,3.1,3.4,2.8c0.4-0.4-4.6-5.7-2.8-7.9 c0-0.1,3,2.9,3.2,2.7"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.6,92.3c0.2-0.3,3.5,3.1,3.6,3c0.7-0.8,1.2-0.6,1.9-1.5c0.1-0.2,3,2.7,3.1,2.6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.4,85.4c0,0,3.2,2.7,3.2,2.7s-2.9-4.4-2.3-5.2c0,0,3,2.7,3.1,2.6"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65,89.9c0,0,3.4,3.6,3.8,3.2c1.1-1.2-1-3.1-0.1-4.3c0.1-0.2,3.1,3.2,3.4,2.9s4.8,1.3,6.2-0.4 c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.8,99.5c0.5-0.5,4.2,5,4.9,4.1c0.2-0.2,1.6-2.3,2.5-3.5c0-0.1,3,2.7,3.1,2.6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.3,107.4c0.2-0.2,3.6,3.4,3.8,3.2c0.2-0.2,0.1-3.4,1.1-4.6c0.1-0.1,3.1,3,3.3,2.8"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.8,103.9c0.3-0.4,3.7,4,4.1,3.5c0.2-0.2,1.7-2.3,2.6-3.4c0.1-0.1,3.3,3.2,3.5,2.9"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.1,102.7c0,0,3.9,3.8,4.2,3.5c0.3-0.8,0.6-1.6,1-2.4c0,0,2.9,2.6,3,2.5"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.9,101.5c0.1-0.2,3.5,3.7,3.8,3.2"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.1,108.4c0.1-0.1,2.8,2.8,3,2.5s-1.1-3.6,0-4.9c0,0,3,2.8,3.1,2.6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M72.6,107c0.2-0.2,3.4,3.6,3.8,3.2c0.2-0.2-1-2.7-0.2-3.7c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63.7,101.5c0.1-0.1,2.9,2.7,3,2.5c0.1-0.1,0-2,0.6-2.7c0.1-0.1,3.3,3.4,3.6,3"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.5,97.4c0.1-0.1,3.1,2.9,3.3,2.7c0.2-0.2-0.8-3,0.1-4.2c0,0,2.9,2.6,3,2.5"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.1,127.2c0.2-0.1,3.2,3.1,3.4,2.8c0.2-1.1,0.6-2.1,1.1-3c0,0,2.9,2.7,3,2.6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.4,102.9c0-0.1,3,2.8,3.1,2.6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.7,102.5c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.8,102c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.3,71.1c0-0.1,3,2.8,3.2,2.7"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.4,106c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72.9,94.5c0.1-0.1,3,2.8,3.2,2.7"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.8,102.4c0,0,2.9,2.6,3,2.5"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,121.9c1-1.1,5.8,7.8,7.3,6.1c0.4-0.5-6.6-6.5-4.3-9.2c0.5-0.6,5.7,7.7,7.1,6"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.9,122.6c0.1-0.1,3.6,3.6,3.9,3.3"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.6,123.9c1.7-2,8.1,11.9,10.6,8.9c0.2-0.2,0.9-2.9,1.9-4c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,130.9c0,0,3.8,4.1,4.2,3.6c1.5-1.7-2.3-4.4-1-6c0.9-1,5.6,7.4,6.9,5.8c0.3-0.4-1.2-4.2,0-5.7 c1,0.9,2.1,1.8,3.2,2.7"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.8,118.5c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.2,152.8c0,0,3.4,3.5,3.8,3.2c1.7-2-4.5-4.8-2.8-6.8c0.2-0.2,3.4,3.5,3.7,3.1c0.3-0.4-3.3-5.1-1.7-7 c0,0,2.9,2.5,2.9,2.4"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.2,142.3c0.1-0.1,3,2.8,3.2,2.7"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M62.1,52.3c0.5-0.5,5.2,4.8,5.4,4.5c1.5-1.8-1.7-4.3-1.3-4.8c3.5-4.2-1.7,3.9,0.9,0.8c0.3-0.3,3-1.1,3.7-2 c4-4.7,2.8,2.5,2.9,2.4c0.1-0.1-3-5.9-2-7c7.2-8.5,2.5,7.7,5.3,4.4c0.2-0.2-7.6-5.9-5.9-7.9c5.4-6.4,6.2,23.2,15.1,12.6 c3.5-4.2-20.2-13.2-15.6-18.6c3.2-3.8,10,9.9,10.7,9.1c1.8-2.2-8.3-9.6-6.9-11.3c5.3-6.3,20.9,19.9,22.1,18.5 c2.6-3.2-22.4-18.7-20.2-21.4c0.2-0.2,3.3,14.7,9.2,7.7c1.2-1.5-1.2-3.9-0.1-5.3c2.9-3.4,0.2,9,4.5,3.8c0.3-0.3-2.2-4.6-0.8-6.3 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M87.5,82c0.6-0.7,6.8,5.9,6.9,5.8c1.5-1.7-6.2-8.3-5.1-9.7c2.3-2.8,9.8,9.2,10.3,8.6 c1.5-1.8-11.6-11.6-10.3-13.1c0.1-0.2-0.8,7.4,3.2,2.7c1-1.1,1.6-2.1,2.5-3.2c1.5-1.7,7.4,10.7,9.6,8.1c0.3-0.4-3.6-5.3-2-7.2 c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.8,50.4c0.1-0.1,3.8,3.9,4.1,3.5"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50,56.7c0.5-0.5,3.7,3.4,3.9,3.2c0.2-0.2-1.2-6-1-6.2c0.9-1.1,5.1,4.9,5.3,4.5c1.7-2.1-4.6-4.5-3.2-6.1 c0.4-0.5,3.7,3.6,3.9,3.3c1-1.2-5.9-4-3.9-6.4c1.2-1.4,3.1,5.9,4.7,4c0.1-0.2-6-7-5-8.1c0.6-0.7,6.1,5.7,6.4,5.4 c3.5-4.2-7.1-8.8-6.1-9.9c1.3-1.5,6,7,7,5.8c0.7-0.8-7.1-7.2-5.2-9.4c0.5-0.6,4.9,4.3,4.9,4.2c0.1-0.1-3.6-6.2-2.6-7.5 c0.4-0.6,3.9,3.6,4.1,3.4c0.1-0.2-4.1-4.2-3-5.6c0.3-0.3,3.5,3.8,3.9,3.3c1-1.1-2.4-5-1.1-6.5c0.3-0.3,4.9,4.3,5,4.2 c0.7-0.8,0.5-3.9,1.1-4.5s3.1,2.9,3.3,2.7c0.4-0.4,0.1-3.7,0.4-4.1c0,0,4.5,5.4,5.3,4.4c1.1-1.3-0.3-3.4,0.7-4.7 c0.3-0.4,3.7,4,4.2,3.5c0.2-0.2,0-3.4,1.1-4.7c0.1-0.1,3.3,3.3,3.5,3"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M75.8,86.7c0.4-0.4,3.7,4.3,4.3,3.6c1.5-1.7-6.4-6.5-4.5-8.6c0.8-0.9,8.4,7.5,8.6,7.2 c1.9-2.3-8.8-9.9-7.4-11.6c0.7-0.9,3.5,3.3,3.7,3.1c0.8-1-4.8-7.1-4.1-7.9c0,0,4.8,5.9,5.7,4.8c2.8-3.4-8.7-7.2-6.1-10.3 c0.6-0.8,4.8,6,5.7,4.8c0.4-0.5-5.8-6.2-3.7-8.7c0.1-0.1,3.3,3.3,3.6,3"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.7,27.1c0.7-0.8,4.1,4.2,4.4,3.7"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M99.4,41.8c0.4-0.4,4.7,5.3,5.4,4.5c3.2-3.8-16.4-9.3-11.6-15.1c0.3-0.3,10.5,12.7,12.5,10.4 c0,0-4.6-5.5-3.8-6.4c0.1,0,3.3,3.2,3.5,2.9"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.2,32c0.2-0.2,3.7,4.2,4.2,3.6"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.2,65.7c0.1-0.1,3,2.6,3,2.6"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86,67.8c0.7-0.9,4.2,4.3,4.5,3.8"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.3,71.3c0.6-0.7,6.2,7.5,7.3,6.2c1.9-2.2-8.3-6.6-5.4-10c0.1-0.2,7.1,8.2,8.2,6.9c0,0-0.7-3.1-0.3-3.5 c0.1-0.1,3.5,3.4,3.7,3.1"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80,69.5c0.1,0,4,4.4,4.5,3.8c2.1-2.5-6.1-5.6-4.1-7.9c0.1-0.1,3.1,2.8,3.2,2.7c0.3-0.4-3.2-5.1-1.6-6.9 c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.3,59.8c0.1-0.1,3.2,2.7,3.2,2.7c0.5-0.6-0.7-3.4-0.4-3.7c0.2-0.3,1.8,1.6,1.8,1.5c0.3-0.4,1.6-2.6,1.9-2.9 c0,0,3.5,3.7,3.9,3.3c1.2-1.4-0.8-3.6,0.3-4.9c0.5-0.6,4.4,5.3,5.2,4.4c0.2-0.2,0.6-3.1,1.6-4.3c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.6,60.1c0.2-0.3-0.6,2.1,0.7,0.6"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.7,65.7c0.1-0.2,3.2,3.1,3.4,2.9c0.5-0.5-7.2-6.3-4.9-9c0.3-0.3,4.3,5.2,5.1,4.2"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.1,58.3c0,0,3.2,3.1,3.4,2.8c0.8-0.9,0.1-2.3,0.8-3.2c0.4-0.4,4,4.5,4.5,3.8c0.5-1.4,1.2-2.7,2-3.9 c0.2-0.2,3.9,4.4,4.4,3.7"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.2,88.8c0.4-0.5,4.1,4.8,4.8,4s-11.5-8.6-8.2-12.5c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.9,57.4c0-0.1,3.6,3.8,4,3.3c2.3-2.8-6.5-6.2-4.4-8.8c0.3-0.4,3.8,4.2,4.3,3.6c0.5-0.6-6.9-6.7-4.6-9.4 c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53.6,55.8c0.4-0.5,4.2,4.8,4.8,4c0.2-0.2,0.7-3,1.7-4.2c0,0,2.9,2.7,3,2.6"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.7,25.2c0.1-0.1,3,2.9,3.2,2.7s2.8-1.2,3.8-2.4c0.3-0.3,4.2,5,4.9,4.1"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.3,64.4c0.1-0.1,3,3.1,3.3,2.8c0.3-0.4-1.2-4.2,0-5.7c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.3,57.7c0.2-0.3,3.6,3.4,3.7,3.1c0.2-0.2,2-2,2.9-3.1c0.1-0.2,3.5,3.7,3.9,3.2"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83,60.3c0.3-0.4,3.8,4.2,4.3,3.6c0.3-0.3-1.7-4.4-0.4-5.9c0-0.1,3,2.8,3.1,2.6"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.1,56.7c0.1-0.1,3.4,3.5,3.7,3.1"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.1,87.8c0-0.1,3,2.7,3.1,2.6"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87,89.4c0,0,2.9,2.6,3,2.5"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.9,103c0.1-0.1,3,2.8,3.2,2.7s-0.9-2.7-0.1-3.7c0.1-0.1,3.1,3,3.3,2.8"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.9,61.4c0,0,3.5,3.7,3.9,3.3c1.1-1.3-2.6-3.2-1.6-4.5c0.6-0.8,4.8,6,5.8,4.9c0.5-1.4,1.2-2.7,1.9-3.9 c0.1-0.1,3.4,3.5,3.8,3.2"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,60.6c0,0,3,2.6,3,2.5c0.7-0.8-0.8-2.8,0.2-4c0,0,3.8,3.7,4,3.4c0,0-0.9-3.2-0.5-3.7c0,0,3.3,3.3,3.6,3"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.6,61.1c0.1-0.1,3,2.9,3.2,2.7c0.2-0.3,0.2-3.3,1.3-4.5c0.3-0.3,4.2,4.9,4.8,4.1"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,58.2c0.3-0.3,4.3,5.1,5,4.2"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.9,63.5c0.1-0.1,3.1,2.8,3.2,2.7c0.5-1.2,1.1-2.4,1.9-3.5c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.2,65c0,0,3.2,3.1,3.4,2.8"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.6,66.4c0,0,3.7,4.1,4.2,3.5c1-1.2,2.3-1.4,3.2-2.5c0.3-0.3,3.6,3.9,4,3.4c0.2-0.2,2.2-1.8,3.1-3 c0.2-0.2,3.8,4.2,4.3,3.6"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,66c0.2-0.2,3.4,3.6,3.8,3.2c0.2-0.2,1.8-2.2,2.7-3.3c0.1-0.1,3.3,3.4,3.6,3"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.4,69.1c0.2-0.3,3.6,3.8,4,3.3c0.2-0.2,0-2.9,0.9-3.9c0.2-0.2,3.6,3.8,4,3.3"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M90.7,68.4c0.1-0.2,3.5,3.7,3.9,3.2"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.1,77.5c0,0,3,2.7,3.1,2.6"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.1,71.9c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.3,68c0.1-0.1,1.2,1.1,1.2,1.1c0.8-0.9-4.4-6.6-3.8-7.3c0-0.1,5.6,7.4,6.9,5.8c1.6-2-3.3-4.9-1.8-6.7 c0.6-0.7,4.7,5.9,5.7,4.8c0.2-0.3,3.4-0.5,4.5-1.8c0.2-0.2,3.9,4.4,4.4,3.7"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.8,64.8c0,0,3,2.7,3.1,2.6c0.9-1.1-1-2.9-0.1-3.9c0.6-0.8,4.8,6,5.8,4.8c1.1-0.9,2.2-1.9,3.2-2.9 c0-0.1,3.2,3.2,3.4,2.9"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.6,67.6c0-0.1,3.2,3.2,3.4,2.9"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,63.3c0.1-0.1,3.2,3,3.4,2.8c0.9-1.1-1.7-3.9-0.3-5.6c0-0.1,4.2,4.3,4.5,3.8c0,0-1.7-3.7-1.2-4.3 c0.1-0.1,4.2,4.7,4.8,4"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,62.7c0,0,3.2,3.1,3.4,2.9c1.4-1.7-3-4.2-1.6-5.8c0.8-0.9,5.3,6.9,6.5,5.4c0.3-0.3-2.4-4.7-1-6.4 c0.3-0.3,4.3,5.2,5.1,4.3"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.9,68.4c0.1-0.1,1.2,1,1.2,1c0.4-0.5-1.1-3.5-0.8-3.9c0,0,3.6,3.8,4,3.3c1.2-1.4-0.8-3.7,0.3-5 c0.6-0.8,4.8,6,5.8,4.9c0.2-0.3-0.7-3.9,0.4-5.3c0,0,3,2.7,3.1,2.6"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.2,71.7c0.1,0,3.2,3.2,3.5,2.9c1.2-1.4-0.7-3.6,0.4-4.9c0.5-0.6,4.4,5.3,5.2,4.3c0.6-1.3,1.2-2.6,2-3.9 c0.1-0.1,3,2.8,3.2,2.7"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.3,65.8c0-0.1,3,2.6,3.1,2.6c0.8-0.9-2.5-3.1-1.3-4.5c1.1,1,2.2,1.9,3.3,2.8c0,0-0.7-3.1-0.4-3.5 c0,0,3,2.7,3.1,2.6"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.6,62.8c0.1-0.1,3,3,3.3,2.7c0.2-0.3-1.1-4.1,0.1-5.5c0,0,3,2.7,3.1,2.6"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,66.2c0.5-0.6,4.4,5.2,5.1,4.3c0.2-0.3-0.6-3.8,0.5-5.2c0.1-0.1,3.1,3,3.3,2.8"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.7,61.9c0,0,3,2.7,3.1,2.6"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.1,62.1c0.6-0.7,4.6,5.7,5.5,4.6c0.7-1.3,1.4-2.5,2.3-3.7c0-0.1,3,2.7,3.1,2.6"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.5,68.5c0,0,3.3,3.3,3.6,3c0.9-1.1-1.5-2.8-0.7-3.8c0.1-0.2,3.3,3.2,3.5,3c0.2-0.2,0.4-3.2,1.4-4.4 c0-0.1,3,2.7,3.1,2.6"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.3,69.3c0.1-0.2,3.4,3.6,3.8,3.2"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48,66.2c0.1-0.1,3.2,3.2,3.5,2.9"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.8,68.1c0.1-0.1,2.9,2.9,3.2,2.7c0.2-0.3-2.2-3.9-1.1-5.3c0.1-0.1,3,2.8,3.2,2.6"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.9,68.7c0-0.1,3,2.8,3.1,2.6"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.3,63.4c0.1-0.1,3.3,3.3,3.6,3"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.2,68.8c0,0,2.9,2.6,3,2.5"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.9,66.3c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.5,23.9c0,0,3,2.7,3.1,2.6"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.1,31.1c0.4-0.5,4.2,4.9,4.8,4.1c0.5-0.6-8.4-7.3-5.8-10.4c0.1-0.2,3.5,3.7,3.9,3.3"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.7,30.8c0.8-1,5.4,7.1,6.7,5.6c0.2-0.3-3.3-3.9-2-5.4c0.2-0.3,4,4.6,4.6,3.9"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69,26.4c0.3-0.3,3.6,3.8,4,3.3c0.2-0.3-0.6-3.8,0.6-5.1c0.1-0.2,3.5,3.8,3.9,3.3"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76,25.1c0.1,0,3.7,3.8,4,3.4"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.1,26.5c0.1-0.1,3,2.9,3.1,2.6c0.2-0.3,0.3-3.3,1.3-4.5c1,0.9,2,1.8,3.1,2.6"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,27.7c0.2-0.3,3.9,4.5,4.5,3.8"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.8,33.2c1,1,2.1,1.9,3.3,2.7"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103,37.3c0.1-0.2,3.2,3.1,3.4,2.9c0.4-0.5-6-5.1-4.1-7.3c0.2-0.2,3.6,3.9,4,3.4"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.4,30.1c0.1-0.1,3,3,3.2,2.7c0.2-0.3-1.1-4,0.1-5.5c0-0.1,3,2.8,3.2,2.6"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.2,28.1c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.1,25.8c0.2-0.3,4.1,4.8,4.8,4"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.3,19.3c0.1-0.2,3.1,2.9,3.2,2.7c0.2-0.2-1.5-2.8-0.7-3.8c0.1-0.1,3.1,3,3.3,2.8"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,18c0,0,2.9,2.5,2.9,2.5"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,19.6c0-0.1,3,2.7,3.1,2.6"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.8,59.4c0-0.1,3.1,3.1,3.3,2.8c1-1.2-1.2-3.2-0.3-4.3c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.5,55.4c0.2-0.2,3.4,2.9,3.4,2.8c1.6-1.9-3.9-3.1-2.1-5.3c0.5-0.6,3.8,3.7,4,3.4"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.8,58.1c0.1-0.1,3.4,3.2,3.6,3c1.5-1.7-2.4-4-1.6-4.9c0.1-0.1,3.1,2.8,3.2,2.7c1.3-1.6-4.7-5.2-2.7-7.7 c0.1-0.1,4.9,5.2,5.5,4.5c0,0-1.3-3.5-0.9-4c0,0,2.9,2.4,2.9,2.4"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.9,46.3c0,0,4.9,6,5.8,4.9c2.1-2.6-5.7-5.9-3.7-8.3c0.3-0.4,3.8,3.9,4.2,3.5S53.4,41,55.1,39 c0,0,2.9,2.6,3,2.5"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.7,59.5c0,0,3.2,3.1,3.4,2.8c1.1-1.3-2.7-3.1-1.7-4.4c0.5-0.6,4.3,5.2,5.1,4.3c0.7-1.3,1.4-2.5,2.3-3.7 c0,0,2.9,2.6,3,2.5"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57,35.9c0.1-0.1,2.9,3,3.1,2.6c0.3-0.3-2.4-4.7-0.9-6.4c0,0,2.9,2.7,3.1,2.6"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.6,33.6c0,0,2.9,2.6,3,2.5"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,35.2c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.1,24.4c0.2-0.2,3.4,3.3,3.6,3c0.2-0.2-0.2-3.3,0.7-4.5c0-0.1,3,2.8,3.1,2.6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,26.8c0.1-0.1,2.8,2.8,3.1,2.6c0.2-0.2-2.6-3.2-1.5-4.4c0-0.1,3,2.7,3.1,2.6"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.8,25.4c0.1-0.1,3,2.8,3.1,2.6"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.4,29.2c0,0,2.9,2.4,2.9,2.4"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.1,43.8c0.1-0.1,3.1,3,3.3,2.8c0.3-0.4-3.6-5.3-2-7.2c0,0,2.9,2.6,3,2.5"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.6,38.8c0.1-0.1,3,2.8,3.1,2.6c0.3-0.3-3.8-4.2-2.4-5.9c0-0.1,3.2,3.2,3.4,2.9"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.1,36.5c0,0,2.9,2.6,3,2.5"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.9,23.1c0.1-0.1,3.1,3,3.3,2.8"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.2,33.6c0,0,2.9,2.5,2.9,2.4"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.3,24.2c0,0,2.9,2.5,2.9,2.4"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M52,83.4c0.8-0.9,6.1,9.5,8.3,6.9"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.6,77.2c1.1-1.3,7.7,6.8,7.9,6.6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53.7,74.6c0.4-0.4,3.6,3.5,3.8,3.2c0.8-1,1.1-3.3,1.6-3.8c0.1-0.1,3.1,2.6,3.1,2.6"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M48.5,75.7c0.3-0.3,4.8,6.5,6,5.1c1.5-1.8-3.4-4.5-2-6.1c0.2-0.3,3.3,2.9,3.4,2.8"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53.3,79.4c0.8-0.9,5.4,5,5.7,4.8c1.5-1.8-3.3-3.1-1.5-5.2c0.7-0.8,4.1,4.2,4.4,3.7"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M59.9,93.3c0.5-0.5,3.7,4.2,4.2,3.6c2.5-2.9-15.9-9.5-12-14.2c0.8-1,15.4,14.9,16.4,13.7 c1.9-2.3-12.7-10.8-10.5-13.4c0.5-0.5,8,9.6,9.4,7.9c4.1-4.8-10.3-9.2-8.1-11.9c0.9-1.1,7.6,9.7,9.2,7.8c2.4-2.9-11.8-7.7-8-12.2 c0.2-0.2,8.3,9.8,9.7,8.1c0,0-3.2-4.6-2.5-5.4c0,0,2.9,2.6,3,2.5"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.8,73.6c1-1.2,6,8.2,7.5,6.3c0.4-0.4-5.6-5.4-3.8-7.6c0.2-0.2,3.8,4.3,4.3,3.6"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.1,75.3c0,0,3.2,3,3.3,2.8"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M51.9,78.4c0,0,5,6.3,6,5c2-2.4-5-5.5-3.1-7.8c0.9-1.1,5.6,7.5,7,5.8c0.3-0.4-3.5-5.2-1.9-7.2 c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.9,71.9c0.2-0.3,3.6,3.1,3.6,3.1c1.6-1.9-3.4-3.2-1.7-5.3c0.8-1,4.3,4.5,4.8,4"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.6,69.2c0.1-0.1,5.3,5.8,6,5c0,0-3.4-4.7-2.7-5.5c0.1-0.1,3.7,3.8,4.1,3.4"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.9,74.7c0,0,3.6,3.9,4,3.4c1.6-1.9-3.8-4.6-2.3-6.4c0.4-0.6,4.3,5,5,4.2c0.3-0.4-3.6-5.3-2-7.2 c0.1-0.1,3,2.9,3.2,2.7"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.3,82c0.2-0.3,3.8,3.7,4,3.4c0.2-0.3-2.6-4.8-1.1-6.5c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.8,86.2c0.3-0.4,3.8,3.8,4.1,3.4c0.3-0.4-4.2-4.5-2.7-6.2c0.1-0.1,3.1,3,3.3,2.8"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72.4,68c0.1-0.2,3.2,3.2,3.4,2.9c0.5-0.6-8.2-7.2-5.7-10.2c0.3-0.3,4.2,5,4.9,4.1"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.6,90.7c0.2-0.3,3.5,3.7,3.9,3.3c0.2-0.3-0.4-3.7,0.7-5c0,0,2.9,2.5,2.9,2.4"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67,87.8c0.2-0.3,3.4,3.5,3.7,3.1c0.4-1.1,0.8-2.2,1.4-3.2c0.2-0.2,3.6,3.9,4.1,3.4"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.7,72.6c0,0,2.9,2.4,2.9,2.4c0.5-1.2,1.1-2.4,1.8-3.6c0.1-0.1,3.1,2.9,3.2,2.7"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.2,108.6c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.2,108.2c0.1-0.1,3,2.8,3.2,2.6"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.4,91.1c0.3-0.4,3.7,4,4.2,3.5c0.3-1,0.7-2,1.2-3c0.1-0.1,3.3,3.3,3.6,3"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M72.7,89.2c0.3-0.4,4.6,5.6,5.5,4.5"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M77.5,103.5c0,0,3,2.7,3.1,2.6"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.5,57c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.8,34.2c0-0.1,3.5,3.5,3.8,3.2"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.3,33.7c0.1-0.1,3.3,3.3,3.5,3"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103,37.9c0-0.1,3,2.8,3.2,2.7"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.6,34c0,0,2.9,2.5,2.9,2.4"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.9,71c0,0,3.7,3.9,4.1,3.4c2.2-2.6-7.2-5.3-5.1-7.7c0.3-0.3,3.6,3.8,4,3.3c0.4-0.5-4.8-5.7-2.9-8 c0,0,3,2.7,3.1,2.6"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.3,67.1c0.1-0.1,2.9,2.8,3.1,2.6c0.2-0.2-1.5-2.9-0.6-4c0,0,2.9,2.6,3,2.5"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.5,59.4c0.3-0.5,3.9,4.6,4.5,3.8c0.2-0.3-0.4-3.6,0.7-5c0-0.1,3.2,3.2,3.4,2.9"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.5,58.1c0,0,3,2.7,3.1,2.6"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.3,63.1c0.1-0.1,3.2,2.6,3.2,2.6c1-1.1-1.1-2.1,0-3.4c0.6-0.7,3.8,3.8,4.1,3.5"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.2,57.7c0,0,3.2,3.1,3.4,2.9"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.7,66c0,0,4.3,5.1,5,4.2c2.4-2.8-8-5.5-5.8-8.1c1.6-1.9,7.8,11.5,10.2,8.6c0.6-0.7-9.2-7.6-6.4-11 c0.2-0.2,3.7,4,4.1,3.5"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.4,57.9c0.3-0.3,4.1,4.9,4.8,4"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,59.6c0.2-0.3,4.1,4.7,4.7,4"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95,59.5c0,0,3,2.7,3.1,2.6"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,65.2c0,0,3,2.8,3.1,2.6"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,63.6c0-0.1,3,2.7,3.1,2.6"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.2,66.1c0,0,3,2.7,3.1,2.6"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.3,65.8c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.7,65.2c0.1-0.1,3.5,3.7,3.9,3.3"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.4,66c0.1-0.1,3.3,3.3,3.6,3"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,63.6c0.2-0.3,4.1,4.8,4.7,4"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.3,69.9c0.1-0.2,3.3,3.1,3.5,2.9s-1.2-3.2-0.3-4.4c0.1-0.1,3.1,2.9,3.3,2.7"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M63.8,66.4c0.1-0.1,3.4,3.4,3.7,3.1"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.8,65.6c0.1-0.1,3.1,3,3.3,2.8"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M69.4,68c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.8,66.6c0.1-0.2,3.5,3.6,3.8,3.2"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.3,55.9c0.1-0.1,2.9,2.8,3.1,2.6c0.2-0.2-2.3-3.2-1.3-4.4c0.1-0.1,3.2,3.1,3.4,2.8"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M56.2,82.1c0.3-0.3,3.6,3.9,4,3.4c0.2-0.3-2.3-3.6-1.1-5c0-0.1,3,2.8,3.2,2.6"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69,71.8c0,0,2.9,2.5,2.9,2.4c0.2-0.3-2.3-4.5-0.9-6.1c0.2-0.2,3.8,4.3,4.3,3.7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f942a656a853acf6b6dc3361c0df0f1d.svg";
export { ForwardRef as ReactComponent };